/* BestyPop live-preview customizer v6 (BP v10.48: group switch easy to find; v10.47: named groups; v10.45: group orders; v10.43: same look on every size) — design engine cleaning, colour adjustment for the fabric, shirt picture in the cart, Design Pass, full control. Needs bp-print-core.js. */
(function () {
  var BP = window.BPPrint;
  var dataEl = document.getElementById('bpc-data');
  var modal = document.getElementById('bpcModal');
  if (!BP || !dataEl || !modal) return;
  var D = JSON.parse(dataEl.textContent);
  document.body.appendChild(modal);   // outside the product form, so no field can submit it

  // Model photos are 1000 px square. Own photos: 15.5 px = 1 inch on the shirt, collar centre at
  // (470, 359.5). Pool models (v10.37) bring their own collar centre and px per inch.
  // "Adjusted for <colour>" (v10.39): the engine's ink rule on the cleaned design for the fabric
  // colour sampled under the print. Resolves {canvas, blob, changed, reason, warn}; the canvas is
  // the size of the source canvas, so it drops in for it.
  BP.inkDesign = BP.inkDesign || function (blob, srcCanvas, hex) {
    return fetch(BP.ENGINE_BASE + '/api/custom/ink?fabric=' + encodeURIComponent(hex.replace('#', '')), { method: 'POST', body: blob, headers: { 'Content-Type': 'image/png' } })
      .then(function (r) {
        if (!r.ok) throw new Error('ink');
        var changed = r.headers.get('X-BP-Changed') === '1';
        var reason = decodeURIComponent(r.headers.get('X-BP-Reason') || ''), warn = decodeURIComponent(r.headers.get('X-BP-Warn') || '');
        return r.blob().then(function (b) {
          return BP.loadImage(URL.createObjectURL(b)).then(function (im) {
            var c = document.createElement('canvas'); c.width = srcCanvas.width; c.height = srcCanvas.height;
            c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
            return { canvas: c, blob: b, changed: changed, reason: reason, warn: warn };
          });
        });
      });
  };

  var OWN = { cx: 470, cy: 359.5, px: 15.5 };
  var IMG = 1000, PX = OWN.px, CX = OWN.cx, CY = OWN.cy, RAD = Math.PI / 180;
  var VIEWS = { chest: { x: 255, y: 300, w: 430, h: 430 }, full: { x: 0, y: 0, w: 1000, h: 1000 } };
  function setGeom(g) {         // same close-up framing in inches on every model
    PX = g.px; CX = g.cx; CY = g.cy;
    var w = 430 / 15.5 * PX;
    VIEWS.chest = { x: CX - 215 / 15.5 * PX, y: CY - 59.5 / 15.5 * PX, w: w, h: w };
  }
  var STYLE = BP.ENGINE_STYLES[String(D.url || '').split('/').pop()] || '';
  var pool = { list: [], slugs: {}, asked: false };
  var G = { data: D.group || null, on: false, people: [], sel: -1, seq: 0, font: 'Bebas Neue', color: '' };   // st.lines: extra text lines (group name)   // v10.45 group orders   // Drive models and colour slugs per listed colour
  var TCOLORS = [['White', '#ffffff'], ['Black', '#111111'], ['Yellow', '#f5c518'], ['Red', '#e23d3d'], ['Pink', '#ff7eb6']];
  var DARK_SHIRT_LUM = 0.35, MIN_W = 0.5, TEXT_MIN = 0.2, TEXT_MAX = 6;
  var COARSE = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  var st = {
    color: 0, size: '', view: 'full', layer: 'img', notice: '', model: null,
    photo: null,   // see setPhoto()
    text: { s: '', f: BP.FONTS[0].fam, c: '#ffffff', picked: false, cx: 0, cy: 0, sz: 1.2, rot: 0 },
    back: null, sleeve: null, sleeveSide: 'Right sleeve', backOn: false, sleeveOn: false,
    passId: '', approvedAt: null, lines: []
  };
  var shirts = {}, shirtLum = {}, shirtHex = {}, undoStack = [];
  var $ = function (id) { return document.getElementById(id); };
  // Missing required choice (owner 29 Oct 2026, BP v10.40): bring it into view just below the
  // pinned shirt preview (phones and tablets; the panel itself scrolls on computers), flash it and
  // put the cursor on it. scrollIntoView centred it behind the preview, so nothing seemed to move.
  function showMissing(el, focusEl) {
    var sc = null;
    for (var p = el.parentElement; p; p = p.parentElement) {
      var oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 1) { sc = p; break; }
    }
    var stage = modal.querySelector('.bpc-stage'), cover = 0;
    if (sc && stage && sc.contains(stage) && getComputedStyle(stage).position === 'sticky') cover = stage.getBoundingClientRect().height;
    if (sc) {
      var top = el.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - cover - 16;
      sc.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    el.classList.remove('bpc-flash'); void el.offsetWidth; el.classList.add('bpc-flash');
    if (focusEl) setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); } }, 450);
  }
  // The upload button is a label: keyboard Enter / Space opens the file picker like a tap.
  (function (lb) { if (lb) lb.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $('bpcFrontFile').click(); } }); })($('bpcFrontFile') && $('bpcFrontFile').previousElementSibling);
  var cv = $('bpcCanvas'), ctx = cv.getContext('2d');
  var mctx = document.createElement('canvas').getContext('2d');

  function money(c) { return '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }); }
  function clean(s) { return String(s || '').trim().toLowerCase(); }
  function abs(u) { return u && u.indexOf('//') === 0 ? location.protocol + u : u; }
  function area() { return BP.area(st.size, STYLE); }
  // v10.43 (owner 30 Oct 2026): the model photo stands for a size M shirt, so the preview looks the
  // same for every size; only the inches change. A bigger size's print is drawn smaller on the photo
  // by M's print width ÷ that size's (2XL 12 in on women's draws like M's 10 in). DPX = photo pixels
  // per print inch; PX stays the photo's own scale (framing, crops).
  function DPX() { var a = area(), m = BP.area(BP.refSize(STYLE), STYLE); return PX * (a.w > 0 ? m.w / a.w : 1); }
  function colorName() { return D.colors[st.color] ? D.colors[st.color].name : ''; }
  function shortTitle() { return String(D.title).split('Bestypop ').join('').split(' – Customize').join(''); }
  function design() { return { photo: st.photo, text: st.text.s ? st.text : null, lines: st.lines && st.lines.length ? st.lines : null }; }
  function lum(hex) { var n = parseInt(hex.slice(1), 16); return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255; }
  function r1(n) { return Math.round(n * 10) / 10; }

  // ---------- variant lookup ("Heather grey" matches the "Grey" variant) ----------
  function matchColor(o, name) { var a = clean(o), b = clean(name); if (!a || !b) return false; return a === b || b.split(' ').indexOf(a) > -1 || a.split(' ').indexOf(b) > -1; }
  function findVariant() {
    return D.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return opts.some(function (o) { return clean(o) === clean(st.size); }) && (!D.colors.length || opts.some(function (o) { return matchColor(o, colorName()); }));
    }) || null;
  }

  // ---------- keep the design inside the size's print area (rotation aware) ----------
  function fitLayer(box, scaleFn, moveFn) {
    var A = area(), shrunk = false;
    if (!box) return false;
    var k = Math.min(1, A.w / box.w, A.h / box.h);
    if (k < 0.999) { scaleFn(k * 0.999); shrunk = true; box = null; }
    return shrunk;
  }
  function clamp() {
    var A = area(), shrunk = false, p = st.photo, t = st.text;
    if (p) {
      shrunk = fitLayer(BP.photoBox(p), function (k) { p.w *= k; p.h = p.w * p.ih / p.iw; }) || shrunk;
      var b = BP.photoBox(p);
      p.cx += Math.max(0, -A.w / 2 - b.x) - Math.max(0, b.x + b.w - A.w / 2);
      p.cy += Math.max(0, A.top - b.y) - Math.max(0, b.y + b.h - (A.top + A.h));
    }
    if (t.s) {
      shrunk = fitLayer(BP.textBox(mctx, t), function (k) { t.sz *= k; }) || shrunk;
      var tb = BP.textBox(mctx, t);
      t.cx += Math.max(0, -A.w / 2 - tb.x) - Math.max(0, tb.x + tb.w - A.w / 2);
      t.cy += Math.max(0, A.top - tb.y) - Math.max(0, tb.y + tb.h - (A.top + A.h));
    }
    return shrunk;
  }

  // ---------- undo ----------
  function snap() {
    var p = st.photo;
    return JSON.stringify({ p: p ? { cx: p.cx, cy: p.cy, w: p.w, rot: p.rot, flip: p.flip, mode: p.mode } : null, t: { s: st.text.s, f: st.text.f, c: st.text.c, cx: st.text.cx, cy: st.text.cy, sz: st.text.sz, rot: st.text.rot } });
  }
  function pushUndo() { var s = snap(); if (undoStack[undoStack.length - 1] !== s) { undoStack.push(s); if (undoStack.length > 60) undoStack.shift(); } }
  function undo() {
    var cur = snap();
    while (undoStack.length) {
      var s = undoStack.pop(); if (s === cur) continue;
      var o = JSON.parse(s), p = st.photo;
      if (o.p && p) { if (o.p.mode !== p.mode) useMode(o.p.mode, true); p.cx = o.p.cx; p.cy = o.p.cy; p.w = o.p.w; p.h = p.w * p.ih / p.iw; p.rot = o.p.rot; p.flip = o.p.flip; }
      Object.assign(st.text, o.t); $('bpcText').value = st.text.s;
      st.notice = ''; sync(); return;
    }
  }

  // ---------- drawing ----------
  var layers = [];
  function layer(i, w, h) { var c = layers[i] || (layers[i] = document.createElement('canvas')); w = Math.max(1, Math.round(w)); h = Math.max(1, Math.round(h)); if (c.width !== w) c.width = w; if (c.height !== h) c.height = h; return c; }
  // Shirt photo for the chosen colour on the chosen model (own photo, or a Drive model recoloured)
  function shirtKey(i) { return STYLE + ':' + (st.model ? st.model.id : 'own') + ':' + i; }   // v10.45: per style (group rows switch listings)
  function shirtUrl(i) {
    return st.model ? BP.ENGINE_BASE + '/api/custom/shirt/' + STYLE + '/' + pool.slugs[i] + '.jpg?m=' + st.model.id + '&v=' + st.model.v : D.colors[i].img;
  }
  function loadShirt(i, cb) {
    var key = shirtKey(i);
    if (shirts[key]) return cb();
    BP.loadImage(shirtUrl(i)).then(function (im) {
      shirts[key] = im;
      try { var t = document.createElement('canvas').getContext('2d'); t.canvas.width = 1; t.canvas.height = 1; t.drawImage(im, CX, CY + 15 * PX, 2, 2, 0, 0, 1, 1); var px = t.getImageData(0, 0, 1, 1).data; shirtLum[key] = (0.299 * px[0] + 0.587 * px[1] + 0.114 * px[2]) / 255; shirtHex[key] = '#' + [px[0], px[1], px[2]].map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join(''); } catch (e) { shirtLum[key] = 0.5; }
      cb();
    }).catch(function () {
      if (st.model) { pickModel(null); return; }    // a model photo that can't load: back to our own photo
      $('bpcLoading').textContent = 'Preview could not load. You can still add your design.';
    });
  }
  function light() { var k = shirtKey(st.color); return (shirtLum[k] == null ? 0.5 : shirtLum[k]) > DARK_SHIRT_LUM; }
  function photoEl() { var p = st.photo; if (!p) return null; if (p.mode === 'ink' && p.ink) return p.ink.canvas; if (p.mode === 'cut' && p.cut) return p.cut.canvas; return p.orig.el; }

  // Screen-space helpers: how many inches is one CSS pixel on the canvas right now
  function inchPerCss() { var r = cv.getBoundingClientRect(), v = VIEWS[st.view]; return r.width ? v.w / r.width / DPX() : 0.05; }
  function handleGeom(which) {
    var o = which === 'img' ? st.photo : (st.text.s ? st.text : null); if (!o) return null;
    var loc = which === 'img' ? BP.photoLocal(o) : BP.textLocal(mctx, o);
    var corners = BP.corners(loc, o.cx, o.cy, o.rot);
    var ipc = inchPerCss(), off = (COARSE ? 34 : 26) * ipc, c = Math.cos(o.rot * RAD), s = Math.sin(o.rot * RAD);
    var tx = (loc.x0 + loc.x1) / 2, ty = loc.y0 - off;
    var rot = { x: o.cx + tx * c - ty * s, y: o.cy + tx * s + ty * c };
    var top = { x: o.cx + tx * c - loc.y0 * s, y: o.cy + tx * s + loc.y0 * c };
    return { o: o, loc: loc, corners: corners, rot: rot, top: top, r: (COARSE ? 9 : 6) * ipc };
  }

  // Render shirt + design. view = region of the 1000px photo shown; guides = editing marks
  function render(c, w, h, view, guides) {
    var shirt = shirts[shirtKey(st.color)], s = w / view.w, A = area(), d = design();
    c.setTransform(1, 0, 0, 1, 0, 0); c.fillStyle = '#ffffff'; c.fillRect(0, 0, w, h);
    c.setTransform(s, 0, 0, s, -view.x * s, -view.y * s);
    if (!shirt) return;
    c.drawImage(shirt, 0, 0, IMG, IMG);
    var DP = DPX(), ax = CX - A.w / 2 * DP, ay = CY + A.top * DP, aw = A.w * DP, ah = A.h * DP, F = 4;
    if (d.photo || d.text) {
      var M = layer(0, aw * F, ah * F), mc = M.getContext('2d');
      mc.setTransform(1, 0, 0, 1, 0, 0); mc.globalCompositeOperation = 'source-over'; mc.globalAlpha = 1; mc.clearRect(0, 0, M.width, M.height);
      BP.draw(mc, d, photoEl(), DP * F, A.w / 2 * DP * F, -A.top * DP * F);
      var L = M;
      if (light()) {      // the shirt's folds and shadows show through the print
        L = layer(1, M.width, M.height); var lc = L.getContext('2d');
        lc.setTransform(1, 0, 0, 1, 0, 0); lc.globalCompositeOperation = 'source-over'; lc.globalAlpha = 1;
        lc.clearRect(0, 0, L.width, L.height); lc.drawImage(M, 0, 0);
        lc.globalCompositeOperation = 'multiply'; lc.globalAlpha = 0.85; lc.drawImage(shirt, -ax * F, -ay * F, IMG * F, IMG * F);
        lc.globalCompositeOperation = 'destination-in'; lc.globalAlpha = 1; lc.drawImage(M, 0, 0);
        lc.globalCompositeOperation = 'source-over';
      }
      c.globalAlpha = 0.97; c.drawImage(L, ax, ay, aw, ah); c.globalAlpha = 1;
    }
    if (!guides) return;
    var ink = light() ? 'rgba(236,79,64,.9)' : 'rgba(255,255,255,.8)', px1 = 1 / s;
    if (drag) {   // print-area box only while the design is being moved or resized (v10.38)
      c.save(); c.lineWidth = 1.6 * px1; c.setLineDash([6 * px1, 5 * px1]); c.strokeStyle = ink; c.strokeRect(ax, ay, aw, ah); c.restore();
      c.save(); c.font = '600 ' + (11 * px1) + 'px Arial, sans-serif'; c.fillStyle = ink; c.textAlign = 'left'; c.textBaseline = 'bottom';
      c.fillText('Max for ' + A.size + ': ' + A.w + ' × ' + A.h + ' in', ax, ay - 4 * px1); c.restore();
    }
    var u = BP.union(mctx, d);
    if (!u) return;
    if (!st.sel && !drag) return;   // handles and size label only once the design is tapped (v10.38)
    // selection frame + handles on the active layer
    var g = handleGeom(st.layer === 'txt' && st.text.s ? 'txt' : 'img');
    if (g) {
      var toPx = function (p) { return [CX + p.x * DP, CY + p.y * DP]; };
      var dark = light() ? '#242424' : '#ffffff';
      c.save(); c.lineWidth = 1.4 * px1; c.strokeStyle = '#EC4F40'; c.setLineDash([]);
      c.beginPath(); g.corners.forEach(function (p, i) { var q = toPx(p); if (i) c.lineTo(q[0], q[1]); else c.moveTo(q[0], q[1]); }); c.closePath(); c.stroke();
      var tp = toPx(g.top), rp = toPx(g.rot);
      c.beginPath(); c.moveTo(tp[0], tp[1]); c.lineTo(rp[0], rp[1]); c.stroke();
      var hr = g.r * DP;
      g.corners.forEach(function (p) { var q = toPx(p); c.beginPath(); c.arc(q[0], q[1], hr, 0, Math.PI * 2); c.fillStyle = '#ffffff'; c.fill(); c.lineWidth = 2 * px1; c.strokeStyle = '#EC4F40'; c.stroke(); });
      c.beginPath(); c.arc(rp[0], rp[1], hr * 1.15, 0, Math.PI * 2); c.fillStyle = '#EC4F40'; c.fill();
      // rotate icon
      c.strokeStyle = '#ffffff'; c.lineWidth = 1.6 * px1; c.beginPath(); c.arc(rp[0], rp[1], hr * 0.55, -Math.PI * 0.2, Math.PI * 1.3); c.stroke();
      c.restore();
      if (drag && drag.mode === 'rotate') {
        c.save(); c.font = '700 ' + (12 * px1) + 'px Arial, sans-serif'; c.fillStyle = dark; c.textAlign = 'center'; c.textBaseline = 'bottom';
        c.fillText(BP.deg(g.o.rot), rp[0], rp[1] - hr * 1.6); c.restore();
      }
    }
    var label = BP.sizeText(u) + (st.layer === 'txt' && st.text.s ? (BP.norm(st.text.rot) ? ' · ' + BP.deg(st.text.rot) : '') : (st.photo && BP.norm(st.photo.rot) ? ' · ' + BP.deg(st.photo.rot) : ''));
    var fs = 12 * px1, ux = CX + u.x * DP, uy = CY + u.y * DP, uw = u.w * DP, uh = u.h * DP;
    c.save(); c.font = '700 ' + fs + 'px Arial, sans-serif';
    var tw = c.measureText(label).width + 12 * px1, th = fs + 8 * px1, lx = ux + uw / 2 - tw / 2, ly = Math.min(uy + uh + 10 * px1, ay + ah + 6 * px1);
    c.fillStyle = '#EC4F40'; c.beginPath(); if (c.roundRect) c.roundRect(lx, ly, tw, th, th / 2); else c.rect(lx, ly, tw, th); c.fill();
    c.fillStyle = '#ffffff'; c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillText(label, lx + tw / 2, ly + th / 2 + 0.5 * px1); c.restore();
  }
  function draw() { render(ctx, cv.width, cv.height, VIEWS[st.view], true); }

  // Cut-out of exactly what gets printed, on a checkerboard, with rulers (used by the Pass)
  function drawCutout(c, x, y, size, opts) {
    opts = opts || {};
    var u = BP.union(mctx, design()); if (!u) return;
    c.save(); c.beginPath(); c.rect(x, y, size, size); c.clip();
    var q = 16; for (var i = 0; i * q < size; i++) for (var j = 0; j * q < size; j++) { c.fillStyle = (i + j) % 2 ? '#ececec' : '#f9f9f9'; c.fillRect(x + i * q, y + j * q, q, q); }
    var pad = opts.pad || 64, ppi = Math.min((size - pad * 2) / u.w, (size - pad * 2) / u.h);
    var ox = x + size / 2 - (u.x + u.w / 2) * ppi, oy = y + size / 2 - (u.y + u.h / 2) * ppi;
    BP.draw(c, design(), photoEl(), ppi, ox, oy);
    c.restore();
    var bx = ox + u.x * ppi, by = oy + u.y * ppi, bw = u.w * ppi, bh = u.h * ppi;
    c.save(); c.strokeStyle = '#EC4F40'; c.fillStyle = '#EC4F40'; c.lineWidth = 2;
    var ry = by + bh + 22, rx = bx + bw + 22;
    c.beginPath(); c.moveTo(bx, ry); c.lineTo(bx + bw, ry); c.moveTo(bx, ry - 7); c.lineTo(bx, ry + 7); c.moveTo(bx + bw, ry - 7); c.lineTo(bx + bw, ry + 7);
    c.moveTo(rx, by); c.lineTo(rx, by + bh); c.moveTo(rx - 7, by); c.lineTo(rx + 7, by); c.moveTo(rx - 7, by + bh); c.lineTo(rx + 7, by + bh); c.stroke();
    c.font = '700 ' + (opts.fs || 22) + 'px Arial, sans-serif'; c.textAlign = 'center'; c.textBaseline = 'top';
    c.fillText(BP.inch(u.w) + ' in', bx + bw / 2, ry + 8);
    c.translate(rx + 10, by + bh / 2); c.rotate(-Math.PI / 2); c.textBaseline = 'top'; c.fillText(BP.inch(u.h) + ' in', 0, 0);
    c.restore();
  }

  // ---------- warnings ----------
  function warnings() {
    var w = [], p = st.photo, t = st.text, isLight = light();
    if (st.notice) w.push(['info', st.notice]);
    if (p) {
      var dpi = Math.round(p.iw / p.w);
      if (dpi >= 150) w.push(['ok', 'Sharp print at ' + BP.inch(p.w) + ' in wide.']);
      else if (dpi >= 100) w.push(['warn', 'Good print. A larger photo would print sharper.']);
      else w.push(['bad', 'May print blurry at this size. Make it smaller or use a bigger photo.']);
      if (p.mode !== 'ink' && p.ink && p.ink.changed) w.push(['warn', 'Some colours will barely show on ' + colorName() + '. Tap "Adjusted for ' + colorName() + '" to fix them.']);
      if (p.cutState === 'busy') w.push(['info', 'Removing the background, about 10 seconds. You can carry on choosing your size.']);
      else if (p.mode === 'cut') w.push(['info', p.cutKind === 'person' ? 'Background removed. Check the edges, especially hair.' : 'We removed the background. Check that nothing is missing.']);
      else if (p.weakCut) w.push(['warn', 'Shown as uploaded. Our background removal was not sure about this one; tap "Background removed" to compare.']);
      else if (p.cutState === 'ready') w.push(['info', 'Shown as uploaded. Tap "Background removed" to compare.']);
      else if (p.cutState === 'none' && p.cutKind !== 'clear') w.push(['info', 'Your photo prints as shown. We could not remove its background.']);
      else if (p.orig.info.opaque) w.push(['info', 'Your photo prints as a rectangle, background included.']);
      if (p.orig.info.opaque) w.push(['info', 'Tip: a screenshot or photo of a design picks up whatever was around it. If you have the design file itself (PNG with a transparent background), that prints cleanest.']);
      if (p.mode !== 'cut' && p.orig.info.soft) w.push(['warn', 'Soft or see-through edges may print patchy.']);
      if (!isLight && p.orig.info.lum < 0.2) w.push(['warn', 'Dark photo on a dark shirt will be hard to see.']);
    }
    if (t.s) {
      var l = BP.textLocal(mctx, t);
      if (l && l.y1 - l.y0 < 0.5) w.push(['warn', 'Text under ½ in tall may not print cleanly.']);
      if (!isLight && lum(t.c) < 0.25) w.push(['warn', 'Dark text on a dark shirt will be hard to see.']);
      if (isLight && lum(t.c) > 0.85) w.push(['warn', 'Light text will not show on a light shirt.']);
    }
    return w;
  }

  // ---------- UI ----------
  function build() {
    D.colors.forEach(function (c, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bpc-color'; b.setAttribute('aria-label', c.name);
      b.innerHTML = '<img alt="" src="' + abs(c.thumb) + '">';
      b.addEventListener('click', function () {
        st.color = i;
        // the chosen model in this colour, or our own photo when that model has none in it
        if (st.want && pool.slugs[i]) { st.model = st.want; setGeom(st.want); }
        else if (st.model) { st.model = null; setGeom(OWN); }
        loadShirt(i, function () { if (!st.text.picked) st.text.c = light() ? '#111111' : '#ffffff'; requestInk(); sync(); }); sync();
      });
      $('bpcColors').appendChild(b);
    });
    buildPresets();
    var ib = document.createElement('button'); ib.type = 'button'; ib.className = 'bpc-bgopt'; ib.dataset.bg = 'ink'; ib.hidden = true;
    ib.innerHTML = '<canvas id="bpcThumbI" width="120" height="120"></canvas><span id="bpcInkLabel">Adjusted</span>';
    $('bpcBg').appendChild(ib);
    D.sizes.forEach(function (s) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bpc-chip'; b.textContent = s; b.dataset.size = s;
      b.addEventListener('click', function () {
        pushUndo(); st.size = s; $('bpcSizeErr').hidden = true; $('bpcSizes').classList.remove('is-err');
        if (st.photo && st.photo.preset && st.photo.preset !== 'custom') applyPreset(st.photo.preset, true);
        st.notice = clamp() ? 'Resized to fit size ' + area().size + ' (max ' + area().w + ' × ' + area().h + ' in).' : '';
        sync();
      });
      $('bpcSizes').appendChild(b);
    });
    BP.FONTS.forEach(function (f) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bpc-font'; b.textContent = f.label; b.dataset.fam = f.fam;
      b.style.fontFamily = '"' + f.fam + '", cursive'; b.style.fontWeight = f.wt;
      b.addEventListener('click', function () { pushUndo(); st.text.f = f.fam; st.layer = 'txt'; clamp(); sync(); });
      $('bpcFonts').appendChild(b);
    });
    TCOLORS.forEach(function (t) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bpc-tcolor'; b.style.background = t[1];
      b.setAttribute('aria-label', 'Text color ' + t[0]); b.dataset.color = t[1];
      b.addEventListener('click', function () { pushUndo(); st.text.c = t[1]; st.text.picked = true; st.layer = 'txt'; sync(); });
      $('bpcTColors').appendChild(b);
    });
  }
  function sides() {
    var s = [];
    if (st.photo || st.text.s) s.push('Front');
    if (st.backOn && st.back) s.push('Back');
    if (st.sleeveOn && st.sleeve) s.push(st.sleeveSide);
    return s;
  }
  function extras() { return Math.max(0, sides().length - 1); }
  function total() { return D.price + extras() * D.extraPrice; }
  function each(id, fn) { [].forEach.call($(id).children, fn); }
  function active() { return st.layer === 'img' ? st.photo : (st.text.s ? st.text : null); }
  function textH(t) { var l = BP.textLocal(mctx, t); return l ? l.y1 - l.y0 : 0; }
  function setVal(el, v) { if (document.activeElement !== el) el.value = v; }

  function sync() {
    var A = area(), d = design(), u = BP.union(mctx, d), t = st.text, p = st.photo;
    if (!$('bpcDesignErr').hidden && sides().length) $('bpcDesignErr').hidden = true;
    $('bpcColorName').textContent = colorName();
    each('bpcColors', function (b, i) { b.setAttribute('aria-pressed', i === st.color); });
    each('bpcSizes', function (b) { b.setAttribute('aria-pressed', b.dataset.size === st.size); });
    each('bpcFonts', function (b) { b.setAttribute('aria-pressed', b.dataset.fam === t.f); });
    each('bpcTColors', function (b) { b.setAttribute('aria-pressed', b.dataset.color === t.c); });
    $('bpcSizeHint').textContent = st.size ? 'Print area for ' + A.size + ': up to ' + A.w + ' × ' + A.h + ' in, starting ' + A.top + ' in below the collar. It looks the same on your ' + A.size + ' shirt as in this preview.' : 'Pick your size to see your exact print area.';
    $('bpcFonts').hidden = !t.s; $('bpcTColors').hidden = !t.s;
    if (st.layer === 'img' && !p && t.s) st.layer = 'txt';
    if (st.layer === 'txt' && !t.s && p) st.layer = 'img';
    var o = active();
    $('bpcAdjust').hidden = !o;
    $('bpcLayerSeg').hidden = !(p && t.s);
    each('bpcLayerSeg', function (b) { b.setAttribute('aria-pressed', b.dataset.layer === st.layer); });
    if (o) {
      var isImg = st.layer === 'img', sc = $('bpcScale');
      $('bpcSizeLabel').textContent = isImg ? 'Width' : 'Height';
      if (isImg) { sc.min = MIN_W; sc.max = Math.max(A.w, A.h); setVal(sc, p.w); setVal($('bpcSizeNum'), r1(p.w)); }
      else { var th = textH(t), ratio = th / t.sz || 1; sc.min = r1(TEXT_MIN * ratio) || 0.1; sc.max = r1(Math.min(TEXT_MAX * ratio, A.h)); setVal(sc, th); setVal($('bpcSizeNum'), r1(th)); }
      var rot = BP.norm(o.rot); setVal($('bpcRot'), rot > 180 ? rot - 360 : rot); setVal($('bpcRotNum'), rot > 180 ? r1(rot - 360) : r1(rot));
      $('bpcFlip').hidden = !isImg; $('bpcFlip').setAttribute('aria-pressed', !!(isImg && p.flip));
    }
    $('bpcUndo').disabled = !undoStack.length;
    $('bpcFrontRemove').hidden = !p;
    var fn = $('bpcFrontName'); fn.textContent = p ? '✓ ' + p.orig.file.name : 'JPG or PNG. It appears on the shirt right away.'; fn.classList.toggle('is-set', !!p);
    // background choice
    $('bpcBg').hidden = !p;
    if (p) {
      each('bpcBg', function (b) { b.setAttribute('aria-pressed', b.dataset.bg === p.mode); });
      var cutBtn = $('bpcBg').querySelector('[data-bg="cut"]');
      cutBtn.disabled = p.cutState === 'none';
      var grade = $('bpcCutGrade'); grade.hidden = p.cutState !== 'ready';
      if (p.cutState === 'ready') { grade.textContent = p.weakCut ? 'Check the edges' : 'Clean cut'; grade.className = 'bpc-grade' + (p.weakCut ? ' warn' : ''); }
      $('bpcPerfect').hidden = p.cutState !== 'ready';
      $('bpcCutLabel').textContent = p.cutState === 'busy' ? (p.cutKind === 'person' ? 'Finding the person…' : 'Removing background… about 10 s')
        : p.cutState === 'none' ? (p.cutKind === 'clear' ? 'No background to remove' : 'Prints as shown')
        : p.cutState === 'error' ? 'Tap to retry' : p.cutKind === 'person' ? 'Person only' : 'Background removed';
      var inkOn = !!(p.ink && p.ink.changed), ib = $('bpcBg').querySelector('[data-bg="ink"]');
      ib.hidden = !inkOn; $('bpcBg').style.gridTemplateColumns = inkOn ? '1fr 1fr 1fr' : '';
      $('bpcInkLabel').textContent = 'Adjusted for ' + colorName();
    }
    // Owner 29 Oct 2026: customers must see that their colours were adjusted and be able to keep
    // their own, wherever they are on the page: a pill on the preview (one tap toggles) and a line
    // above the choices, which now sit right under the upload button.
    var here = !!(p && inkHere(p)), pill = $('bpcInkPill'), hint = $('bpcInkHint');
    pill.hidden = !here; hint.hidden = !(here && p.mode === 'ink');
    $('bpcBusy').hidden = !(p && p.cutState === 'busy');   // v10.41: the wait shows on the preview itself, every screen size
    if (here) {
      var baseName = p.ink.base === 'cut' ? 'Background removed' : 'Original';
      pill.innerHTML = p.mode === 'ink' ? 'Colours adjusted for ' + esc(colorName()) + ' <b>Keep original</b>' : 'Your original colours <b>Adjust for ' + esc(colorName()) + '</b>';
      hint.textContent = 'We adjusted your design so it shows on ' + colorName() + '. Prefer your own colours? Tap ' + baseName + '.';
    }
    var dims = $('bpcDims');
    if (u) {
      dims.hidden = false; $('bpcDimsMain').textContent = 'Front print: ' + BP.sizeText(u);
      var note = BP.angleNote(d);
      $('bpcDimsSub').textContent = BP.placement(u) + (note ? ' · ' + note : '') + (st.size ? '' : ' · pick your size');
    } else dims.hidden = true;
    var wl = warnings();
    $('bpcWarn').innerHTML = wl.map(function (w) { return '<li class="bpc-w-' + w[0] + '"></li>'; }).join('');
    [].forEach.call($('bpcWarn').children, function (li, i) { li.textContent = wl[i][1]; });
    ['back', 'sleeve'].forEach(function (k) {
      var on = st[k + 'On'];
      modal.querySelector('[data-extra="' + k + '"]').setAttribute('aria-expanded', on);
      $(k === 'back' ? 'bpcBack' : 'bpcSleeve').hidden = !on;
      var nm = $(k === 'back' ? 'bpcBackName' : 'bpcSleeveName');
      if (st[k]) { nm.textContent = '✓ ' + st[k].name; nm.classList.add('is-set'); }
      else { nm.textContent = k === 'back' ? 'Our designer places it and sends you a mockup on WhatsApp.' : 'Up to 3.5 × 3.5 in. Our designer sends you a mockup.'; nm.classList.remove('is-set'); }
    });
    each('bpcSleeveSide', function (b) { b.setAttribute('aria-pressed', b.dataset.side === st.sleeveSide); });
    [].forEach.call(modal.querySelectorAll('.bpc-stagebar [data-zoom]'), function (b) { b.setAttribute('aria-pressed', b.dataset.zoom === st.view); });
    var ex = extras();
    $('bpcTotal').textContent = money(total());
    $('bpcTotalNote').textContent = ex ? '1 print included + ' + ex + ' extra × ' + money(D.extraPrice) : '1 print included';
    var ps = $('bpcPresets');
    if (ps) { ps.hidden = !(p && st.layer === 'img'); each('bpcPresets', function (b) { b.setAttribute('aria-pressed', !!(p && b.dataset.preset === p.preset)); }); }
    if ($('bpcModels')) each('bpcModels', function (b) {
      var id = b.dataset.model;
      b.hidden = !!id && !pool.slugs[st.color];
      b.setAttribute('aria-pressed', (st.model ? st.model.id : '') === id);
    });
    if ($('bpcModels')) $('bpcModels').parentNode.hidden = G.on || !pool.slugs[st.color];   // no model in this colour: no row
    if (G.data) groupSync();
    draw();
  }

  // ---------- photo upload + background choice ----------
  var MAX_MB = 15;   // design engine limit
  function analyse(im) {
    var info = { opaque: true, soft: false, lum: 0.5 };
    try {
      var N = 256, c = document.createElement('canvas'); c.width = N; c.height = N; var g = c.getContext('2d');
      g.drawImage(im, 0, 0, N, N); var px = g.getImageData(0, 0, N, N).data, clear = 0, soft = 0, solid = 0, L = 0;
      for (var i = 0; i < px.length; i += 4) {
        var a = px[i + 3];
        if (a < 10) clear++; else if (a < 245) soft++; else { solid++; L += (0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2]) / 255; }
      }
      var n = px.length / 4; info.opaque = clear / n < 0.01; info.soft = soft / Math.max(1, soft + solid) > 0.2; info.lum = solid ? L / solid : 0.5;
      // Busy edge (a photo of a room, people): the edge pixels are not one colour. Same test as the engine.
      var pts = [], k; for (k = 0; k < N; k += 2) pts.push(k * 4, ((N - 1) * N + k) * 4, (k * N) * 4, (k * N + N - 1) * 4);
      var med = [0, 1, 2].map(function (ch) { return pts.map(function (q) { return px[q + ch]; }).sort(function (a, b) { return a - b; })[pts.length >> 1]; });
      var near = pts.filter(function (q) { return Math.hypot(px[q] - med[0], px[q + 1] - med[1], px[q + 2] - med[2]) < 40; }).length;
      info.busy = info.opaque && near / pts.length < 0.7;
    } catch (e) {}
    return info;
  }
  function setPhoto(file, im, place) {
    var iw = im.naturalWidth, ih = im.naturalHeight;
    st.photo = { orig: { el: im, file: file, iw: iw, ih: ih, info: analyse(im) }, mode: 'orig', cut: null, cutState: 'idle', iw: iw, ih: ih, w: 1, h: 1, cx: 0, cy: 0, rot: 0, flip: false };
    if (place) st.photo.preset = 'custom'; else applyPreset('standard', true);
    if (place) { st.photo.cx = place.cx; st.photo.cy = place.cy; st.photo.w = place.w; st.photo.h = place.w * ih / iw; st.photo.rot = place.rot || 0; st.photo.flip = !!place.flip; }
    undoStack = []; st.layer = 'img'; st.notice = clamp() ? 'Resized to fit size ' + area().size + '.' : '';
    drawThumb('bpcThumbO', im); clearThumb('bpcThumbC');
    if (G.on) { claim(); holder().place = { preset: 'standard' }; placeGroup(); }
    sync();
    startCutout();
  }
  function drawThumb(id, src) {
    var c = $(id), g = c.getContext('2d'), W = c.width, H = c.height;
    g.clearRect(0, 0, W, H);
    for (var i = 0; i * 8 < W; i++) for (var j = 0; j * 8 < H; j++) { g.fillStyle = (i + j) % 2 ? '#e6e6e6' : '#ffffff'; g.fillRect(i * 8, j * 8, 8, 8); }
    if (!src) return;
    var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height, k = Math.min((W - 8) / sw, (H - 8) / sh);
    g.drawImage(src, (W - sw * k) / 2, (H - sh * k) / 2, sw * k, sh * k);
  }
  function clearThumb(id) { drawThumb(id, null); }

  // ---------- print size presets (v10.37, same as the occasion design pages) ----------
  // Standard: full print width for the chosen size. Small: 70 % of that. Pocket: 3.5 in wide on the
  // left chest (the wearer's left = right as you face the shirt), 1 in lower. Top 3 in below the collar.
  var PRESETS = { pocket: 'Pocket', small: 'Small', standard: 'Standard' };
  function applyPreset(name, silent) {
    var p = st.photo; if (!p) return;
    var A = area(), ar = p.ih / p.iw, w;
    if (name === 'pocket') { w = Math.min(3.5, 3.5 / ar); p.cx = 3.75; p.rot = 0; }
    else { w = (name === 'small' ? 0.7 : 1) * A.w; if (w * ar > A.h) w = A.h / ar; p.cx = 0; p.rot = 0; }
    p.w = w; p.h = w * ar;
    p.cy = A.top + (name === 'pocket' ? 1 : 0) + p.h / 2;
    p.preset = name; st.layer = 'img';
    clamp();
    if (!silent) sync();
  }
  function markCustom() { if (st.photo && st.layer === 'img') st.photo.preset = 'custom'; }
  function presetLabel() {
    var p = st.photo; if (!p) return '';
    return (PRESETS[p.preset] || 'Custom') + ', ' + BP.inch(p.w) + ' in wide';
  }
  function buildPresets() {
    var seg = document.createElement('div'); seg.className = 'bpc-seg bpc-presets'; seg.id = 'bpcPresets';
    seg.setAttribute('role', 'group'); seg.setAttribute('aria-label', 'Print size');
    Object.keys(PRESETS).forEach(function (k) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.preset = k; b.textContent = PRESETS[k];
      b.addEventListener('click', function () { pushUndo(); st.notice = ''; st.sel = true; if (G.on) { holder().place = { preset: k }; placeGroup(); sync(); } else applyPreset(k); });
      seg.appendChild(b);
    });
    var adj = $('bpcAdjust'); adj.insertBefore(seg, adj.firstChild);
  }

  // ---------- "Shown on": our own photo, or a model from the Drive Models folder (v10.37) ----------
  // v10.39: the model list is fetched while the product page loads, and the customizer waits for
  // it before showing a shirt, so our own photo no longer flashes for 2-3 s before the model
  // (owner 28 Oct 2026). No answer in 4 s: our own photo, as before.
  // v10.45: one pool per style (group rows use other listings); callbacks keep the pool, style and
  // colours they were asked for, so switching person mid-load cannot mix them up.
  var pagePool = pool, pageStyle = STYLE;
  function poolReady(fn) { if (pool.done || !STYLE) fn(); else (pool.wait = pool.wait || []).push(fn); }
  function poolDone(P) { if (P.done) return; P.done = true; var w = P.wait || []; P.wait = []; w.forEach(function (f) { f(); }); }
  function loadPool() {
    var P = pool, S = STYLE, cols = D.colors;
    if (P.asked || !S) return; P.asked = true;
    setTimeout(function () { poolDone(P); }, 4000);
    fetch(BP.ENGINE_BASE + '/api/custom/models/' + S).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.models || !j.models.length) return;
      cols.forEach(function (c, i) { var hit = (j.colours || []).find(function (x) { return matchColor(x.name, c.name); }); if (hit) P.slugs[i] = hit.slug; });
      P.list = j.models;
      if (P === pagePool) buildModels();
      if (P === pool && !G.on && !st.model) { st.want = P.list[0]; if (P.slugs[st.color]) { st.model = P.list[0]; setGeom(st.model); st.view = 'full'; } }
      if (P === pool && G.on) groupShow();
      sync();
    }).catch(function () {}).then(function () { poolDone(P); });
  }
  function buildModels() {
    var wrap = document.createElement('div'); wrap.className = 'bpc-shown';
    wrap.innerHTML = '<div class="bpc-shown-h">Shown on</div><div class="bpc-models" id="bpcModels"></div>';
    var row = wrap.lastChild;
    var add = function (m) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bpc-model'; b.dataset.model = m ? m.id : '';
      var img = document.createElement('img'); img.alt = ''; img.loading = 'lazy';
      img.src = m ? BP.ENGINE_BASE + '/mf/' + pageStyle + '/' + m.id + '.jpg' : abs(D.colors[st.color].thumb);
      if (!m) img.className = 'is-own';
      var lab = document.createElement('span'); lab.textContent = m ? m.label : 'Our model';
      b.appendChild(img); b.appendChild(lab);
      b.addEventListener('click', function () { pickModel(m); });
      row.appendChild(b);
    };
    pool.list.forEach(add);   // no "Our model" chip (v10.38): a Drive model is shown by default
    var cols = $('bpcColors'); cols.parentNode.insertBefore(wrap, cols.nextSibling);
    var css = document.createElement('style');
    css.textContent = '.bpc-shown{margin:14px 0 4px}.bpc-shown-h{font-size:13px;font-weight:700;margin:0 0 8px}.bpc-models{display:flex;gap:10px;flex-wrap:wrap}'
      + '.bpc-model{display:flex;flex-direction:column;align-items:center;gap:4px;background:none;border:0;padding:0;cursor:pointer;font-size:11px;color:#555}'
      + '.bpc-model img{width:46px;height:46px;border-radius:50%;object-fit:cover;border:2px solid #e5e5e5;background:#f2f2f2}'
      + '.bpc-model img.is-own{object-position:50% 20%}.bpc-model[aria-pressed="true"] img{border-color:#EC4F40}.bpc-model[aria-pressed="true"]{color:#242424;font-weight:700}'
      + '.bpc-model[hidden]{display:none}.bpc-presets{margin:0 0 12px}';
    document.head.appendChild(css);
  }
  function pickModel(m) {
    if (m) st.want = m;                       // remembered when a colour has no photo of this model
    if (m && !pool.slugs[st.color]) return;
    st.model = m; setGeom(m ? m : OWN);
    if (m) st.view = 'full';   // show the person's face with the design
    loadShirt(st.color, function () { $('bpcLoading').hidden = true; if (!st.text.picked) st.text.c = light() ? '#111111' : '#ffffff'; requestInk(); sync(); });
    sync();
  }
  // v10.37: every upload goes to the design engine first. A plain background (screenshot box, white
  // JPG background) is removed there and the clean version is picked for the customer; a busy photo
  // falls back to the in-browser person cut-out ("Person only"). Engine unreachable → person cut-out.
  // v10.49: a group person's own image (or the group design) keeps processing while another
  // person is on the stage; only the thumbnails and the stage wait until it is shown again.
  function live(x) { return st.photo === x || (G.on && (G.main === x || G.people.some(function (q) { return q.photo === x; }))); }
  function thumbs() {
    var p = st.photo; drawThumb('bpcThumbO', p ? p.orig.el : null); drawThumb('bpcThumbC', p && p.cut ? p.cut.canvas : null);
    if ($('bpcThumbI')) drawThumb('bpcThumbI', p && p.ink && p.ink.changed ? p.ink.canvas : null);
  }
  function startCutout() {
    var p = st.photo; if (!p || p.cutState === 'busy') return;
    p.cutState = 'busy'; sync();
    var mine = p;
    BP.cleanDesign(p.orig.file, p.orig.el).then(function (res) {
      if (!live(mine)) return;
      // The cutout model handles photos too; the in-browser person cut-out is only for when the
      // engine had to fall back to its rules on a busy photo.
      if (res.photo && res.method !== 'model') { personCut(mine); return; }
      if (!res.keyed) { mine.cutKind = 'clear'; mine.cutState = 'none'; sync(); requestInk(); return; }
      mine.cut = res; mine.cutKind = 'clean'; mine.cutState = 'ready'; if (st.photo === mine) drawThumb('bpcThumbC', res.canvas);
      // v10.41 (owner 30 Oct 2026): the app never switches to the cut-out on its own. "Original" stays
      // selected; "Background removed" sits next to it as a thumbnail to compare. A cut the engine
      // is not confident in is still offered, with a note.
      if (res.quality !== 'ok') mine.weakCut = true;
      sync(); requestInk();
      // A better cut is being made in the background: swap it in when it lands (the thumbnail, and
      // the preview too if the customer is already on "Background removed").
      if (res.later) BP.cleanLater(res.later, mine.orig.el).then(function (better) {
        if (!better || !live(mine) || !better.keyed) return;
        if (st.photo !== mine) { mine.cut = better; mine.weakCut = false; if (mine.ink && mine.ink.base === 'cut') mine.ink = null; return; }
        // On the old cut (or its adjusted version): step to Original with the old crop, then back.
        var onCut = mine.mode === 'cut' || (mine.mode === 'ink' && mine.ink && mine.ink.base === 'cut');
        if (onCut) useMode('orig', true);
        mine.cut = better; mine.weakCut = false; if (mine.ink && mine.ink.base === 'cut') mine.ink = null;
        drawThumb('bpcThumbC', better.canvas);
        if (onCut) { useMode('cut', true); clamp(); }
        sync(); requestInk();
        if (!$('bpcCutWin').hidden) cutWindow();   // the window shows the better cut and its grade
      });
    }).catch(function () {
      if (!live(mine)) return;
      // The engine did not answer in time: the design prints as shown. The in-browser person
      // cut-out is only for photos with a busy background (never "No person found" on a logo).
      if (mine.orig.info.busy) personCut(mine); else { mine.cutKind = 'clean'; mine.cutState = 'none'; sync(); requestInk(); }
    });
  }
  function personCut(mine) {
    mine.cutKind = 'person'; mine.cutState = 'busy'; sync();
    BP.removeBackground(mine.orig.el).then(function (res) {
      if (!live(mine)) return;
      mine.cut = res; mine.cutState = 'ready'; if (st.photo === mine) drawThumb('bpcThumbC', res.canvas);
      sync(); requestInk();
    }).catch(function (err) {
      if (!live(mine)) return;
      mine.cutState = String(err && err.message) === 'noperson' ? 'none' : 'error'; sync(); requestInk();
    });
  }
  // v10.39 "Adjusted for <colour>": once the design is settled (cleaned, or kept as uploaded), the
  // engine judges its colours against the fabric under the print and recolours only the parts that
  // would not show (pale yellow lettering on a white tee). When it changed something, that version
  // is shown unless the customer already chose one; Original stays one tap away. Re-run per colour.
  // The adjusted version made for the shirt colour now shown (not one still left from the last colour).
  function inkHere(p) { var k = p.ink && p.ink.changed ? p.ink.key : ''; return !!k && k.slice(0, k.lastIndexOf(':')) === shirtKey(st.color); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function inkSource(p) { return p.cut && (p.cutState === 'ready') ? { base: 'cut', blob: p.cut.blob, canvas: p.cut.canvas } : { base: 'orig', blob: p.orig.file, canvas: null }; }
  function requestInk() {
    var p = st.photo; if (!p || p.cutState === 'busy' || p.cutState === 'idle') return;
    var key = shirtKey(st.color), hex = shirtHex[key]; if (!hex) return;
    var src = inkSource(p), want = key + ':' + src.base;
    if (src.base === 'orig' && p.orig.info.opaque) return;   // would also remove its background unasked
    if (p.ink && p.ink.key === want) return;
    if (p.inkBusy) { p.inkNext = true; return; }
    p.inkBusy = true; p.inkNext = false;
    var canvas = src.canvas; if (!canvas) { canvas = document.createElement('canvas'); canvas.width = p.orig.iw; canvas.height = p.orig.ih; canvas.getContext('2d').drawImage(p.orig.el, 0, 0); }
    var body = src.blob && src.blob.type === 'image/png' ? Promise.resolve(src.blob) : toBlob(canvas, 'image/png');
    body.then(function (b) { return BP.inkDesign(b, canvas, hex); }).then(function (res) {
      if (st.photo !== p) return;
      res.key = want; res.base = src.base; p.ink = res;
      // Owner 29 Oct 2026: the adjusted version on every shirt colour that needs it. A customer's
      // own tap (Original / Background removed) counts for the colour it was made on only.
      if (res.changed) { drawThumb('bpcThumbI', res.canvas); if (p.userPicked !== key && p.mode === src.base) { useMode('ink', true); clamp(); } }
      else if (p.mode === 'ink') { useMode(src.base, true); clamp(); }
    }).catch(function () { if (st.photo === p && p.mode === 'ink') { p.ink = null; useMode(src.base, true); } })
    .then(function () { p.inkBusy = false; if (st.photo !== p) return; sync(); if (p.inkNext) requestInk(); });
  }
  // switch between original and cut-out, keeping the same physical scale and position
  // Where each version sits inside the original (ink is drawn on the cut-out or the original).
  function modeCrop(p, mode) {
    var O = p.orig, full = { x: 0, y: 0, w: O.iw, h: O.ih };
    if (mode === 'cut') return p.cut ? p.cut.crop : null;
    if (mode === 'ink') return p.ink ? (p.ink.base === 'cut' ? (p.cut ? p.cut.crop : null) : full) : null;
    return full;
  }
  function useMode(mode, silent) {
    var p = st.photo; if (!p || p.mode === mode) return;
    var from = modeCrop(p, p.mode), to = modeCrop(p, mode); if (!from || !to) return;
    var k = p.w / p.iw;
    var dx = (to.x + to.w / 2) - (from.x + from.w / 2), dy = (to.y + to.h / 2) - (from.y + from.h / 2);
    var lx = dx * k * (p.flip ? -1 : 1), ly = dy * k;
    var c = Math.cos(p.rot * RAD), s = Math.sin(p.rot * RAD);
    p.cx += lx * c - ly * s; p.cy += lx * s + ly * c;
    p.iw = to.w; p.ih = to.h;
    p.w = p.iw * k; p.h = p.ih * k; p.mode = mode;
    if (p.preset && p.preset !== 'custom') applyPreset(p.preset, true);   // trimmed artwork: refit the chosen size
    if (!silent) { clamp(); sync(); }
  }
  $('bpcInkPill').addEventListener('click', function () {
    var p = st.photo; if (!p || !inkHere(p)) return;
    p.userPicked = shirtKey(st.color); pushUndo(); useMode(p.mode === 'ink' ? p.ink.base : 'ink');
  });
  $('bpcBg').addEventListener('click', function (e) {
    var b = e.target.closest('[data-bg]'), p = st.photo; if (!b || !p) return;
    if (b.dataset.bg === 'cut') {
      if (p.cutState === 'error' || p.cutState === 'idle') { startCutout(); return; }
      if (p.cutState !== 'ready') return;
    }
    if (b.dataset.bg === 'ink' && !(p.ink && p.ink.changed)) return;
    p.userPicked = shirtKey(st.color); pushUndo(); useMode(b.dataset.bg);
    if (b.dataset.bg === 'cut' && !p.seenCut) { p.seenCut = true; cutWindow(); }
  });
  // "Background removed" window (v10.41, owner 30 Oct 2026): original and cut side by side, and the
  // way to a perfect file: copy a prompt written for this kind of upload, open ChatGPT, upload the
  // result here. Opens the first time the cut is picked, and from "Want a perfect cut?".
  function cutWindow() {
    var p = st.photo; if (!p || !p.cut) return;
    var weak = !!p.weakCut, prompt = BP.cleanPrompt(p.cut.kind);
    drawThumb('bpcWinO', p.orig.el); drawThumb('bpcWinC', p.cut.canvas);
    var g = $('bpcWinGrade'); g.textContent = weak ? 'Check the edges' : 'Clean cut'; g.className = 'bpc-grade' + (weak ? ' warn' : '');
    $('bpcWinNote').textContent = (weak ? 'Our automatic cut was not sure about this one. Check the edges before you order.' : 'Our automatic cut can miss fine detail.') + ' For a perfect file, let ChatGPT clean it in three steps:';
    $('bpcPromptText').textContent = prompt; $('bpcCopyPrompt').textContent = 'Copy the prompt';
    $('bpcCutWin').hidden = false; $('bpcCutWinX').focus();
  }
  function closeCutWindow() { $('bpcCutWin').hidden = true; }
  $('bpcCutWinX').addEventListener('click', closeCutWindow);
  $('bpcCutWinUse').addEventListener('click', closeCutWindow);
  $('bpcCutWin').addEventListener('click', function (e) { if (e.target === $('bpcCutWin')) closeCutWindow(); });
  $('bpcPerfect').addEventListener('click', cutWindow);
  $('bpcCopyPrompt').addEventListener('click', function () {
    var p = st.photo, text = p && p.cut ? BP.cleanPrompt(p.cut.kind) : BP.cleanPrompt('logo'), b = this;
    navigator.clipboard.writeText(text).then(function () { b.textContent = 'Copied'; }, function () { $('bpcPromptText').parentNode.open = true; b.textContent = 'Select and copy the text'; });
  });
  $('bpcReup').addEventListener('click', function () { closeCutWindow(); $('bpcFrontFile').click(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !$('bpcCutWin').hidden) { e.stopPropagation(); closeCutWindow(); } }, true);
  $('bpcFrontFile').addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0]; e.target.value = '';
    if (!f) return;
    if (f.size > MAX_MB * 1048576) { $('bpcFrontName').textContent = 'This photo is over ' + MAX_MB + ' MB. Please choose a smaller one.'; return; }
    var im = new Image();
    im.onload = function () { setPhoto(f, im); };
    im.onerror = function () { $('bpcFrontName').textContent = 'This photo type cannot be shown. Please choose a JPG or PNG.'; };
    im.src = URL.createObjectURL(f);
  });
  $('bpcFrontRemove').addEventListener('click', function () { pushUndo(); st.photo = null; st.notice = ''; undoStack = []; if (G.on) claim(); sync(); });
  $('bpcText').addEventListener('focus', pushUndo);
  $('bpcText').addEventListener('input', function (e) {
    var t = st.text, was = !!t.s; t.s = e.target.value; st.layer = 'txt';
    if (!was && t.s) {
      var A = area(), pb = BP.photoBox(st.photo);
      t.cx = 0; t.rot = 0; t.cy = pb ? pb.y + pb.h + t.sz * 0.8 : A.top + t.sz;
      if (!t.picked) t.c = light() ? '#111111' : '#ffffff';
    }
    clamp(); sync();
  });
  function bindExtra(k, id) {
    $(id).addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; e.target.value = '';
      if (!f) return;
      if (f.size > MAX_MB * 1048576) { $(k === 'back' ? 'bpcBackName' : 'bpcSleeveName').textContent = 'File is over ' + MAX_MB + ' MB. Please choose a smaller one.'; return; }
      st[k] = f; sync();
    });
  }
  bindExtra('back', 'bpcBackFile'); bindExtra('sleeve', 'bpcSleeveFile');
  modal.querySelectorAll('[data-extra]').forEach(function (b) { b.addEventListener('click', function () { var k = b.dataset.extra; st[k + 'On'] = !st[k + 'On']; if (!st[k + 'On']) st[k] = null; sync(); }); });
  modal.querySelectorAll('[data-extra-remove]').forEach(function (b) { b.addEventListener('click', function () { var k = b.dataset.extraRemove; st[k] = null; st[k + 'On'] = false; sync(); }); });
  $('bpcSleeveSide').addEventListener('click', function (e) { var b = e.target.closest('[data-side]'); if (b) { st.sleeveSide = b.dataset.side; sync(); } });
  $('bpcLayerSeg').addEventListener('click', function (e) { var b = e.target.closest('[data-layer]'); if (b) { st.layer = b.dataset.layer; sync(); } });
  modal.querySelectorAll('.bpc-stagebar [data-zoom]').forEach(function (b) { b.addEventListener('click', function () { st.view = b.dataset.zoom; sync(); }); });

  // ---------- exact controls ----------
  function setSize(v) {          // photo width or text height, inches
    var o = active(); if (!o || !(v > 0)) return;
    st.sel = true;
    markCustom();
    if (st.layer === 'img') { o.w = Math.max(MIN_W, v); o.h = o.w * o.ih / o.iw; }
    else { var th = textH(o), ratio = th / o.sz || 1; o.sz = Math.max(TEXT_MIN, Math.min(TEXT_MAX, v / ratio)); }
    st.notice = clamp() ? 'That is bigger than the print area for ' + area().size + ', so it was set to the largest that fits.' : '';
    sync();
  }
  function setRot(v) { var o = active(); if (!o || isNaN(v)) return; st.sel = true; markCustom(); o.rot = BP.norm(v); st.notice = clamp() ? 'Resized to fit at this angle.' : ''; sync(); }
  function cur() { var o = active(); return o ? (st.layer === 'img' ? o.w : textH(o)) : 0; }
  $('bpcScale').addEventListener('pointerdown', pushUndo); $('bpcScale').addEventListener('keydown', pushUndo);
  $('bpcScale').addEventListener('input', function (e) { setSize(+e.target.value); });
  $('bpcSizeNum').addEventListener('focus', pushUndo);
  $('bpcSizeNum').addEventListener('change', function (e) { setSize(parseFloat(e.target.value)); e.target.value = r1(cur()); });
  $('bpcMinus').addEventListener('click', function () { pushUndo(); setSize(cur() - 0.5); });
  $('bpcPlus').addEventListener('click', function () { pushUndo(); setSize(cur() + 0.5); });
  $('bpcRot').addEventListener('pointerdown', pushUndo); $('bpcRot').addEventListener('keydown', pushUndo);
  $('bpcRot').addEventListener('input', function (e) { setRot(+e.target.value); });
  $('bpcRotNum').addEventListener('focus', pushUndo);
  $('bpcRotNum').addEventListener('change', function (e) { setRot(parseFloat(e.target.value)); });
  $('bpcRotL').addEventListener('click', function () { var o = active(); if (o) { pushUndo(); setRot(o.rot - 90); } });
  $('bpcRotR').addEventListener('click', function () { var o = active(); if (o) { pushUndo(); setRot(o.rot + 90); } });
  $('bpcFlip').addEventListener('click', function () { if (st.photo && st.layer === 'img') { pushUndo(); st.photo.flip = !st.photo.flip; sync(); } });
  $('bpcCenter').addEventListener('click', function () { var o = active(); if (o) { pushUndo(); markCustom(); o.cx = 0; clamp(); sync(); } });
  $('bpcReset').addEventListener('click', function () {
    var o = active(); if (!o) return; pushUndo();
    if (st.layer === 'img') { applyPreset('standard', true); }
    else { o.sz = 1.2; o.rot = 0; o.cx = 0; var pb = BP.photoBox(st.photo); o.cy = pb ? pb.y + pb.h + o.sz * 0.8 : area().top + o.sz; }
    st.notice = ''; clamp(); sync();
  });
  $('bpcUndo').addEventListener('click', undo);
  modal.addEventListener('keydown', function (e) {
    var typing = e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA';
    if ((e.ctrlKey || e.metaKey) && !e.shiftKey && (e.key === 'z' || e.key === 'Z') && !typing) { e.preventDefault(); undo(); return; }
    if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'number') e.preventDefault();
    if (e.key === 'Escape') closeAll();
  });

  // ---------- direct manipulation: mouse, finger, wheel ----------
  var pts = {}, drag = null, wheelTimer = null;
  function toInch(e) {
    var r = cv.getBoundingClientRect(), v = VIEWS[st.view];
    var ix = v.x + (e.clientX - r.left) / r.width * v.w, iy = v.y + (e.clientY - r.top) / r.height * v.h;
    var DP = DPX(); return { x: (ix - CX) / DP, y: (iy - CY) / DP };
  }
  function near(a, b, r) { return Math.hypot(a.x - b.x, a.y - b.y) <= r; }
  function hitTest(p) {
    var g = st.sel ? handleGeom(st.layer === 'txt' && st.text.s ? 'txt' : 'img') : null;
    if (g) {
      if (near(p, g.rot, g.r * 2.6)) return { mode: 'rotate' };
      for (var i = 0; i < 4; i++) if (near(p, g.corners[i], g.r * 2.6)) return { mode: 'scale', corner: i };
    }
    var t = st.text;
    if (t.s && !G.on && BP.hit(BP.textLocal(mctx, t), t.cx, t.cy, t.rot, p.x, p.y, 0.1)) return { mode: 'move', layer: 'txt' };
    var ph = st.photo;
    if (ph && BP.hit(BP.photoLocal(ph), ph.cx, ph.cy, ph.rot, p.x, p.y, 0.1)) return { mode: 'move', layer: 'img' };
    return null;
  }
  function sizeOf(o) { return st.layer === 'img' ? o.w : o.sz; }
  function applySize(o, v) {
    if (st.layer === 'img') { o.w = Math.max(MIN_W, v); o.h = o.w * o.ih / o.iw; } else o.sz = Math.max(TEXT_MIN, Math.min(TEXT_MAX, v));
  }
  cv.addEventListener('pointerdown', function (e) {
    var p = toInch(e); pts[e.pointerId] = p; cv.setPointerCapture(e.pointerId);
    var ids = Object.keys(pts);
    if (ids.length === 1) {
      var h = hitTest(p);
      if (!h) { drag = null; if (st.sel) { st.sel = false; sync(); } return; }
      st.sel = true;
      if (h.layer) st.layer = h.layer;
      var o = active(); if (!o) return;
      pushUndo();
      drag = { mode: h.mode, p: p, cx: o.cx, cy: o.cy, size: sizeOf(o), rot: o.rot,
        d0: Math.hypot(p.x - o.cx, p.y - o.cy) || 1, a0: Math.atan2(p.y - o.cy, p.x - o.cx) };
      cv.classList.add('is-drag'); sync();
    } else if (ids.length === 2) {
      var a = pts[ids[0]], b = pts[ids[1]], o2 = active(); if (!o2) return;
      if (!drag) pushUndo();
      drag = { mode: 'pinch', dist: Math.hypot(a.x - b.x, a.y - b.y) || 1, ang: Math.atan2(b.y - a.y, b.x - a.x), size: sizeOf(o2), rot: o2.rot,
        mid: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, cx: o2.cx, cy: o2.cy };
    }
  });
  cv.addEventListener('pointermove', function (e) {
    var p = toInch(e);
    if (!pts[e.pointerId]) {           // hover: show what a drag would do
      var h = hitTest(p);
      cv.style.cursor = !h ? 'default' : h.mode === 'rotate' ? 'crosshair' : h.mode === 'scale' ? 'nwse-resize' : 'move';
      return;
    }
    pts[e.pointerId] = p;
    if (!drag) return;
    var o = active(); if (!o) return;
    markCustom();
    var ids = Object.keys(pts);
    if (drag.mode === 'pinch' && ids.length === 2) {
      var a = pts[ids[0]], b = pts[ids[1]];
      applySize(o, drag.size * Math.hypot(a.x - b.x, a.y - b.y) / drag.dist);
      o.rot = BP.norm(drag.rot + (Math.atan2(b.y - a.y, b.x - a.x) - drag.ang) / RAD);
      o.cx = drag.cx + ((a.x + b.x) / 2 - drag.mid.x); o.cy = drag.cy + ((a.y + b.y) / 2 - drag.mid.y);
    } else if (drag.mode === 'move') {
      o.cx = drag.cx + (p.x - drag.p.x); o.cy = drag.cy + (p.y - drag.p.y);
    } else if (drag.mode === 'scale') {
      applySize(o, drag.size * (Math.hypot(p.x - o.cx, p.y - o.cy) / drag.d0));
    } else if (drag.mode === 'rotate') {
      o.rot = BP.norm(drag.rot + (Math.atan2(p.y - o.cy, p.x - o.cx) - drag.a0) / RAD);
    }
    st.notice = clamp() ? 'That is the largest that fits the print area for ' + area().size + '.' : '';
    sync();
  });
  function endPtr(e) {
    delete pts[e.pointerId];
    var n = Object.keys(pts).length;
    if (!n) { drag = null; cv.classList.remove('is-drag'); sync(); }
    else if (n === 1 && drag && drag.mode === 'pinch') {      // one finger left: continue as a move
      var o = active(), id = Object.keys(pts)[0];
      drag = o ? { mode: 'move', p: pts[id], cx: o.cx, cy: o.cy } : null;
    }
  }
  cv.addEventListener('pointerup', endPtr); cv.addEventListener('pointercancel', endPtr);
  cv.addEventListener('wheel', function (e) {
    var o = active(); if (!o) return;
    e.preventDefault();
    if (!wheelTimer) pushUndo();
    markCustom();
    clearTimeout(wheelTimer); wheelTimer = setTimeout(function () { wheelTimer = null; }, 500);
    var dy = e.deltaY || e.deltaX;
    if (e.shiftKey) o.rot = BP.norm(o.rot + dy * 0.12);
    else applySize(o, sizeOf(o) * Math.exp(-dy * 0.0015));
    st.notice = clamp() ? 'That is the largest that fits the print area for ' + area().size + '.' : '';
    sync();
  }, { passive: false });

  // ---------- true size view ----------
  $('bpcTrueBtn').addEventListener('click', function () {
    var u = BP.union(mctx, design()); if (!u) return;
    var c = $('bpcTrueCanvas'), g = c.getContext('2d'), W = c.width, H = c.height;
    var phone = { w: 2.9, h: 6.1 }, gap = 1.2, totalW = u.w + gap + phone.w, totalH = Math.max(u.h, phone.h);
    var ppi = Math.min((W - 80) / totalW, (H - 120) / totalH), ox = (W - totalW * ppi) / 2, base = H - 70;
    g.setTransform(1, 0, 0, 1, 0, 0); g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
    var dx = ox, dy = base - u.h * ppi;
    g.save(); var q = 12; for (var i = 0; i * q < u.w * ppi; i++) for (var j = 0; j * q < u.h * ppi; j++) { g.fillStyle = (i + j) % 2 ? '#ececec' : '#f9f9f9'; g.fillRect(dx + i * q, dy + j * q, Math.min(q, u.w * ppi - i * q), Math.min(q, u.h * ppi - j * q)); } g.restore();
    BP.draw(g, design(), photoEl(), ppi, dx - u.x * ppi, dy - u.y * ppi);
    var px0 = ox + (u.w + gap) * ppi, py0 = base - phone.h * ppi, pw = phone.w * ppi, ph = phone.h * ppi;
    g.save(); g.strokeStyle = '#242424'; g.lineWidth = 3; g.fillStyle = '#f2f2f2'; g.beginPath(); if (g.roundRect) g.roundRect(px0, py0, pw, ph, 0.35 * ppi); else g.rect(px0, py0, pw, ph); g.fill(); g.stroke();
    g.fillStyle = '#242424'; g.fillRect(px0 + pw / 2 - 0.4 * ppi, py0 + 0.15 * ppi, 0.8 * ppi, 0.12 * ppi); g.restore();
    g.fillStyle = '#242424'; g.font = '700 18px Arial, sans-serif'; g.textAlign = 'center'; g.textBaseline = 'top';
    g.fillText('Your print ' + BP.sizeText(u), dx + u.w * ppi / 2, base + 14);
    g.fillStyle = '#6b6b6b'; g.font = '16px Arial, sans-serif'; g.fillText('A phone, 6.1 in', px0 + pw / 2, base + 14);
    $('bpcTrue').hidden = false;
  });
  $('bpcTrue').addEventListener('click', function (e) { if (e.target === $('bpcTrue') || e.target.closest('[data-close-true]')) $('bpcTrue').hidden = true; });

  // ---------- Design Pass ----------
  function newId() { var a = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789', s = 'D-'; for (var i = 0; i < 5; i++) s += a.charAt(Math.floor(Math.random() * a.length)); return s; }
  function stamp(date) {
    try { return new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' }).format(date) + ' IST'; }
    catch (e) { return date.toISOString().slice(0, 16).replace('T', ' ') + ' UTC'; }
  }
  function frontLine() {
    var d = design(), u = BP.union(mctx, d); if (!u) return '';
    var p0 = st.photo, note = BP.angleNote(d), bg = p0 && p0.mode === 'cut' ? ', background removed' : p0 && p0.mode === 'ink' ? (p0.ink.base === 'cut' ? ', background removed' : '') + ', colours adjusted for ' + colorName() : '';
    return 'Front ' + BP.sizeText(u) + ', ' + BP.placement(u) + (note ? ', ' + note : '') + bg;
  }
  function printSummary() {
    var parts = []; var f = frontLine(); if (f) parts.push(f);
    if (st.backOn && st.back) parts.push('Back (designer mockup)');
    if (st.sleeveOn && st.sleeve) parts.push(st.sleeveSide + ' (designer mockup)');
    return parts.join(' + ');
  }
  function rr(g, x, y, w, h, r) { g.beginPath(); if (g.roundRect) g.roundRect(x, y, w, h, r); else g.rect(x, y, w, h); }
  function makePass(approved) {
    var W = 1080, H = 1350, c = document.createElement('canvas'); c.width = W; c.height = H; var g = c.getContext('2d');
    var d = design(), u = BP.union(mctx, d), A = area(), sans = 'Arial, Helvetica, sans-serif';
    g.fillStyle = '#fff8f6'; g.fillRect(0, 0, W, H);
    g.fillStyle = '#EC4F40'; g.fillRect(0, 0, W, 120);
    g.fillStyle = '#ffffff'; g.font = '800 46px ' + sans; g.textBaseline = 'middle'; g.textAlign = 'left'; g.fillText('BestyPop', 48, 62);
    g.textAlign = 'right'; g.font = '700 20px ' + sans; g.fillText('DESIGN PASS', W - 48, 42); g.font = '800 34px ' + sans; g.fillText(st.passId, W - 48, 80);
    var m = document.createElement('canvas'); m.width = 1000; m.height = 1000; render(m.getContext('2d'), 1000, 1000, VIEWS.full, false);
    g.save(); rr(g, 48, 160, 480, 640, 24); g.clip(); g.fillStyle = '#ffffff'; g.fillRect(48, 160, 480, 640); var rq = PX / 15.5; g.drawImage(m, CX - 300 * rq, CY - 269.5 * rq, 600 * rq, 800 * rq, 48, 160, 480, 640); g.restore();
    g.save(); g.strokeStyle = '#ead9d5'; g.lineWidth = 2; rr(g, 48, 160, 480, 640, 24); g.stroke(); g.restore();
    g.fillStyle = '#6b6b6b'; g.font = '700 18px ' + sans; g.textAlign = 'left'; g.textBaseline = 'alphabetic'; g.fillText('HOW IT LOOKS', 48, 148); g.fillText('WHAT WE PRINT', 568, 148);
    g.save(); rr(g, 568, 160, 464, 464, 24); g.clip(); drawCutout(g, 568, 160, 464, { pad: 70, fs: 22 }); g.restore();
    g.save(); g.strokeStyle = '#ead9d5'; g.lineWidth = 2; rr(g, 568, 160, 464, 464, 24); g.stroke(); g.restore();
    g.fillStyle = '#242424'; g.font = '800 34px ' + sans; g.fillText(u ? 'Front · ' + BP.sizeText(u) : 'Back / sleeve print', 568, 676);
    g.fillStyle = '#4a4a4a'; g.font = '22px ' + sans;
    var y2 = 712;
    if (u) { var pl = BP.placement(u).split(', '); g.fillText(pl[0], 568, y2); y2 += 30; g.fillText(pl.slice(1).join(', ').slice(0, 44), 568, y2); y2 += 30; }
    var an = BP.angleNote(d); if (an) { g.fillText(an.charAt(0).toUpperCase() + an.slice(1), 568, y2); y2 += 30; }
    if (st.photo && (st.photo.mode === 'cut' || (st.photo.mode === 'ink' && st.photo.ink.base === 'cut'))) { g.fillText('Background removed', 568, y2); y2 += 30; }
    if (st.photo && st.photo.mode === 'ink') { g.fillText('Colours adjusted for ' + colorName(), 568, y2); y2 += 30; }
    g.fillText('Max for size ' + A.size + ': ' + A.w + ' × ' + A.h + ' in', 568, y2);
    var rows = [['Shirt', shortTitle() + ' · ' + colorName() + ' · ' + st.size]];
    if (st.text.s) rows.push(['Text', '“' + st.text.s + '” · ' + BP.FONTS[BP.fontIndex(st.text.f)].label]);
    var also = []; if (st.backOn && st.back) also.push('Back'); if (st.sleeveOn && st.sleeve) also.push(st.sleeveSide);
    if (also.length) rows.push(['Also printing', also.join(', ') + ' (mockup on WhatsApp)']);
    rows.push(['Price', money(total()) + (extras() ? ' (incl. ' + extras() + ' extra side' + (extras() > 1 ? 's' : '') + ')' : '')]);
    var y = 900;
    rows.forEach(function (r) { g.fillStyle = '#8a8a8a'; g.font = '700 20px ' + sans; g.fillText(r[0].toUpperCase(), 48, y); g.fillStyle = '#242424'; g.font = '600 28px ' + sans; g.fillText(r[1].slice(0, 46), 48, y + 34); y += 82; });
    if (approved) {
      g.save(); g.translate(812, 1160); g.rotate(-0.08); g.strokeStyle = '#EC4F40'; g.lineWidth = 4; rr(g, -200, -62, 400, 124, 18); g.stroke();
      g.fillStyle = '#EC4F40'; g.textAlign = 'center'; g.font = '800 32px ' + sans; g.fillText('APPROVED BY YOU', 0, -8); g.font = '600 20px ' + sans; g.fillText(stamp(approved), 0, 30); g.restore();
    }
    g.fillStyle = '#8a8a8a'; g.font = '19px ' + sans; g.textAlign = 'center';
    g.fillText('Printed size may vary by up to ¼ in · Custom prints can’t be exchanged · bestypop.in', W / 2, H - 34);
    return c;
  }

  // The shirt with the design, no editing marks, framed like the Pass's "How it looks" (3:4).
  function lookImage() {
    var m = document.createElement('canvas'); m.width = 1000; m.height = 1000; render(m.getContext('2d'), 1000, 1000, VIEWS.full, false);
    var c = document.createElement('canvas'); c.width = 600; c.height = 800; var g = c.getContext('2d'), rq = PX / 15.5;
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, 600, 800);
    g.drawImage(m, CX - 300 * rq, CY - 269.5 * rq, 600 * rq, 800 * rq, 0, 0, 600, 800);
    return c;
  }

  // ---------- open / close / review ----------
  function open() {
    BP.loadFonts().then(function () { if (st.text.s) clamp(); draw(); });
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.classList.add('bpc-lock');
    loadPool();
    poolReady(function () {
      loadShirt(st.color, function () { $('bpcLoading').hidden = true; if (!st.text.picked) st.text.c = light() ? '#111111' : '#ffffff'; requestInk(); sync(); });
    });
    sync();
  }
  function closeAll() {
    if (!$('bpcReview').hidden) { $('bpcReview').hidden = true; return; }
    if ($('bpcGReview') && !$('bpcGReview').hidden) { if (!G.busy) $('bpcGReview').hidden = true; return; }
    if (!$('bpcTrue').hidden) { $('bpcTrue').hidden = true; return; }
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('bpc-lock');
  }
  document.querySelectorAll('[data-bpc-open]').forEach(function (b) { b.addEventListener('click', function (e) {
    e.preventDefault(); open();
    if (G.data) setMode(b.hasAttribute('data-bpc-group'));   // v10.48: "Customize for everyone" opens straight in group mode
  }); });
  modal.querySelectorAll('[data-bpc-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  var chart = $('bpcChart');
  if (chart) {
    modal.querySelector('[data-bpc-chart]').addEventListener('click', function () { chart.hidden = false; });
    chart.addEventListener('click', function (e) { if (e.target === chart || e.target.closest('[data-bpc-chart-close]')) chart.hidden = true; });
  }

  $('bpcAdd').addEventListener('click', function () {
    if (G.on) { groupReview(); return; }
    var ok = true; $('bpcCartErr').hidden = true;
    if (!st.size) { $('bpcSizeErr').hidden = false; $('bpcSizes').classList.add('is-err'); ok = false; }
    var s = sides(); $('bpcDesignErr').hidden = s.length > 0; if (!s.length) ok = false;
    if (!ok) {
      if (!st.size) showMissing($('bpcSizeSec'), $('bpcSizes').querySelector('.bpc-chip'));
      else showMissing($('bpcFrontSec'), $('bpcFrontFile').previousElementSibling || $('bpcText'));
      return;
    }
    var v = findVariant();
    if (!v || !v.available) { $('bpcCartErr').textContent = 'This color and size is sold out. Please pick another size or color.'; $('bpcCartErr').hidden = false; return; }
    if (!st.passId) st.passId = newId();
    var c = makePass(null);
    $('bpcPassImg').src = c.toDataURL('image/jpeg', 0.85);
    $('bpcReviewPrint').textContent = printSummary();
    $('bpcApprove').textContent = 'Approve & add to cart · ' + money(total());
    $('bpcReview').hidden = false;
  });
  $('bpcReview').addEventListener('click', function (e) { if (e.target === $('bpcReview') || e.target.closest('[data-review-edit]')) $('bpcReview').hidden = true; });

  function previewParam() { var t = window.Shopify && window.Shopify.theme; return t && t.role && t.role !== 'main' ? '&preview_theme_id=' + t.id : ''; }
  function toBlob(c, type, q) { return new Promise(function (ok) { try { c.toBlob(function (b) { ok(b); }, type, q); } catch (e) { ok(null); } }); }

  $('bpcApprove').addEventListener('click', async function () {
    var btn = this, v = findVariant(); btn.disabled = true; btn.textContent = 'Uploading…'; $('bpcReviewErr').hidden = true;
    try {
      st.approvedAt = new Date();
      var pass = await toBlob(makePass(st.approvedAt), 'image/jpeg', 0.86);
      var uid = String(Date.now()), ex = extras(), d = design(), u = BP.union(mctx, d), A = area(), p = st.photo;
      var fd = new FormData();
      fd.append('id', v.id); fd.append('quantity', 1);
      fd.append('properties[Design ID]', st.passId);
      fd.append('properties[Print]', printSummary());
      if (p) fd.append('properties[Print size]', presetLabel());
      fd.append('properties[_Shown on]', st.model ? st.model.label : 'Our model');
      if (st.text.s) fd.append('properties[Text]', '“' + st.text.s + '” · ' + BP.FONTS[BP.fontIndex(st.text.f)].label);
      if (ex) fd.append('properties[Extra Prints]', ex + ' × ' + money(D.extraPrice));
      fd.append('properties[Approved]', stamp(st.approvedAt));
      var wa = $('bpcWhatsapp').value.trim(); if (wa) fd.append('properties[WhatsApp]', wa);
      var note = $('bpcNote').value.trim(); if (note) fd.append('properties[Note for designer]', note);
      fd.append('properties[_unique]', uid);
      fd.append('properties[_extras]', String(ex));
      fd.append('properties[_Color]', colorName());
      if (pass) fd.append('properties[_Design Pass]', new File([pass], st.passId + '-pass.jpg', { type: 'image/jpeg' }));
      // v10.39: the cart shows the shirt as the customer saw it (model, colour, final artwork), 3:4
      var look = await toBlob(lookImage(), 'image/jpeg', 0.86);
      if (look) fd.append('properties[_Preview]', new File([look], st.passId + '-shirt.jpg', { type: 'image/jpeg' }));
      if (p) {
        if (p.mode === 'cut' || p.mode === 'ink') {
          var ver = p.mode === 'ink' ? p.ink : p.cut;
          var outBlob = ver.blob || await toBlob(ver.canvas, 'image/png');
          var base0 = String(p.orig.file.name || 'photo'); if (base0.lastIndexOf('.') > 0) base0 = base0.slice(0, base0.lastIndexOf('.'));
          fd.append('properties[_Front File]', new File([outBlob], base0 + (p.mode === 'ink' ? '-adjusted.png' : '-cutout.png'), { type: 'image/png' }));
          fd.append('properties[_Front Original]', p.orig.file);
        } else fd.append('properties[_Front File]', p.orig.file);
      }
      if (st.backOn && st.back) fd.append('properties[_Back File]', st.back);
      if (st.sleeveOn && st.sleeve) { fd.append('properties[_Sleeve File]', st.sleeve); fd.append('properties[_Sleeve Side]', st.sleeveSide); }
      var res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error(await res.text());
      var item = await res.json(), pr = item.properties || {};
      var data = {
        v: 2, id: st.passId, ts: st.approvedAt.toISOString(), t: D.title, pu: D.url, c: colorName(), s: st.size, a: [A.w, A.h, A.top],
        photo: p ? { u: pr['_Front File'] || '', o: pr['_Front Original'] || '', cut: p.mode === 'cut' || (p.mode === 'ink' && p.ink.base === 'cut') ? 1 : 0, ink: p.mode === 'ink' ? 1 : 0, cx: p.cx, cy: p.cy, w: p.w, h: p.h, iw: p.iw, ih: p.ih, rot: p.rot, flip: p.flip ? 1 : 0 } : null,
        text: st.text.s ? { s: st.text.s, f: st.text.f, c: st.text.c, cx: st.text.cx, cy: st.text.cy, sz: st.text.sz, rot: st.text.rot } : null,
        box: u ? [u.x, u.y, u.w, u.h] : null,
        back: pr['_Back File'] || '', sl: pr['_Sleeve File'] || '', side: (st.sleeveOn && st.sleeve) ? st.sleeveSide : '',
        pass: pr['_Design Pass'] || '', p: total()
      };
      var enc = BP.encode(data), base = location.origin;
      var extra = { '_Print File': base + '/pages/print-file?d=' + enc + previewParam(), '_Share': base + '/pages/design-pass?d=' + enc + previewParam() };
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 1, properties: Object.assign({}, pr, extra) }) });
      if (ex && D.extraId) {
        var r2 = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: D.extraId, quantity: ex, properties: { 'Design ID': st.passId, 'For': shortTitle() + ' · ' + v.title, '_link': uid } }] }) });
        if (!r2.ok) throw new Error('extra');
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error('BP customizer:', err);
      $('bpcReviewErr').textContent = String(err && err.message) === 'extra'
        ? 'Your shirt was added, but the extra print charge was not. Please try again or contact us.'
        : 'Could not add to cart. Check your connection and try again. If your photo is very large, try a smaller one.';
      $('bpcReviewErr').hidden = false; btn.disabled = false; btn.textContent = 'Approve & add to cart · ' + money(total());
    }
  });

  // ---------- "Order this design" from a shared Design Pass ----------
  function remix(code) {
    var d; try { d = BP.decode(code); } catch (e) { return; }
    D.colors.forEach(function (c, i) { if (clean(c.name) === clean(d.c)) st.color = i; });
    if (d.s && D.sizes.indexOf(d.s) > -1) st.size = d.s;
    if (d.text) { st.text = { s: d.text.s, f: d.text.f, c: d.text.c, picked: true, cx: d.text.cx, cy: d.text.cy, sz: d.text.sz, rot: d.text.rot || 0 }; $('bpcText').value = d.text.s; }
    open();
    if (d.photo && d.photo.u) {
      fetch(d.photo.u).then(function (r) { return r.blob(); }).then(function (b) {
        var f = new File([b], 'design.' + (b.type.split('/')[1] || 'png'), { type: b.type }), im = new Image();
        im.onload = function () { setPhoto(f, im, { cx: d.photo.cx, cy: d.photo.cy, w: d.photo.w, rot: d.photo.rot, flip: d.photo.flip }); };
        im.src = URL.createObjectURL(b);
      }).catch(function () {});
    }
  }


  // ---------- Group orders (v10.47 named groups; v10.45 first version; owner 30-31 Oct 2026) ----------
  // "For a group": 1 the group (its name, a type that is only a quick start, and where the group name
  // prints: under the design, on the back (+ one extra print side a shirt) or not at all), 2 one
  // design for everyone, 3 one shirt colour for everyone (a colour a fit isn't made in falls back to
  // Black for those people, and says so), 4 people: names typed or pasted, each a compact row with
  // the name printed (or none), quantity, fit (Men / Women / Boys / Girls: its own listing, sizes and
  // price) and size. The stage shows the selected person on their listing's model. Review all shows
  // every shirt; approving adds one cart line per person with its own Design ID, Pass, preview and
  // print file (the person's area, design, group name line and name).
  var GMAX = 12, PAGE = null, pools = {};
  var TYPES = [['company', 'Company / Team', 'Wilson, Samson, Ajit, Priya…'], ['family', 'Family', 'Dad, Mom, Riya, Arjun…'], ['birthday', 'Birthday', 'Riya, Kavya, Arjun, Dev…'], ['church', 'Church / Event', 'Pastor John, Mary, Ann…'], ['school', 'School / Class', 'Asha, Ben, Chitra, Dev…']];
  function fitOf(k) { return G.data.fits.filter(function (f) { return f.key === k; })[0] || null; }
  function fitLabel(k) { var f = fitOf(k); return f ? f.label : k; }
  function sizeLabel(s) { var m = /(\d+)\/(\d+)\s*YRS/i.exec(s || ''); return m ? m[1] + '–' + m[2] + ' yrs' : s; }
  function colorIdx(F, name) { for (var i = 0; i < F.colors.length; i++) if (matchColor(F.colors[i].name, name)) return i; return -1; }
  function useFit(k) {
    var F = fitOf(k); if (!F) return null;
    D.colors = F.colors; D.variants = F.variants; D.sizes = F.sizes; D.title = F.title; D.url = F.url; D.price = F.price;
    STYLE = F.style;
    pool = F.style === pageStyle ? pagePool : (pools[F.style] = pools[F.style] || { list: [], slugs: {}, asked: false });
    return F;
  }
  function usePage() {
    D.colors = PAGE.colors; D.variants = PAGE.variants; D.sizes = PAGE.sizes; D.title = PAGE.title; D.url = PAGE.url; D.price = PAGE.price;
    STYLE = pageStyle; pool = pagePool;
  }
  // A person's shirt colour: the group colour, or (a fit not made in it) Black, else that fit's first colour.
  function colourFor(p) {
    var F = fitOf(p.fit), want = G.same ? G.colour : p.color;
    if (colorIdx(F, want) > -1) return F.colors[colorIdx(F, want)].name;
    return colorIdx(F, 'Black') > -1 ? F.colors[colorIdx(F, 'Black')].name : F.colors[0].name;
  }
  function pname(p, i) { return p.name || 'No name'; }
  function gShirts() { return G.people.reduce(function (n, p) { return n + p.qty; }, 0); }
  function shirtsTxt(n) { return n + (n === 1 ? ' shirt' : ' shirts'); }
  function backOn() { return G.gprint === 'back' && !!G.gname.trim(); }
  function gTotal() { return G.people.reduce(function (n, p) { var F = fitOf(p.fit); return n + ((F ? F.price : D.price) + (backOn() ? D.extraPrice : 0)) * p.qty; }, 0); }
  function newPerson(name) { return { id: ++G.seq, name: String(name || '').toUpperCase().slice(0, 14), fit: G.data.page, color: G.colour, size: '', qty: 1, photo: null, place: null }; }

  // v10.49 own image per person (owner 31 Oct 2026, e.g. Boss Man / Boss Lady / Mini Boss): a row's
  // picture button gives that person their own image; everyone else keeps the group design. The
  // stage always shows G.cur's image (theirs, else G.main), and the design section edits that one.
  function holder() { return G.cur && G.cur.photo && G.cur.photo === st.photo ? G.cur : G; }
  function claim() {
    var p = G.cur;
    if (G.ownFor) { var q = G.ownFor; G.ownFor = null; if (q === p && st.photo) { q.photo = st.photo; q.place = null; return; } }
    if (p && p.photo) {
      if (st.photo === p.photo) return;
      if (st.photo) { p.photo = st.photo; return; }
      p.photo = null; p.place = null; st.photo = G.main; placeGroup(); thumbs(); renderList();   // removed: back to the group design
    } else G.main = st.photo;
  }

  // Where the group design sits, as a share of each person's print area (Standard / Small / Pocket
  // follow each size; a moved or resized design keeps its share of the area).
  function capturePlace() {
    var ph = st.photo; if (!ph || G.placedFor !== placeKey()) return;   // only from the person it was placed for
    var A = area();
    holder().place = ph.preset && ph.preset !== 'custom' ? { preset: ph.preset }
      : { preset: 'custom', wr: ph.w / A.w, cxr: ph.cx / A.w, cyr: (ph.cy - A.top) / A.h, rot: ph.rot, flip: ph.flip };
  }
  function placeKey() { var p = G.cur; return p ? 'p' + p.id : 'page'; }
  function ink() { return G.color || (light() ? '#111111' : '#ffffff'); }
  function nameSz(A) { return Math.max(0.6, Math.min(1.4, A.w * 0.12)); }
  function groupLine() { return G.gprint === 'under' && G.gname.trim() ? G.gname.trim().toUpperCase() : ''; }
  function textRoom(A) {   // inches kept free under the design for the group name line and the names
    var r = 0, anyName = G.people.some(function (q) { return !!q.name; });
    if (groupLine()) { var g = BP.textLocal(mctx, { s: 'NAME', f: G.font, sz: nameSz(A) * 0.6 }); r += (g ? g.y1 - g.y0 : 0.5) + 0.3; }
    if (anyName) { var l = BP.textLocal(mctx, { s: 'NAME', f: G.font, sz: nameSz(A) }); r += (l ? l.y1 - l.y0 : 0.8) + 0.3; }
    return r;
  }
  function placeGroup() {
    var A = area(), ph = st.photo, gp = holder().place || { preset: (ph && ph.preset) || 'standard' };
    if (ph) {
      if (gp.preset === 'custom') {
        ph.w = gp.wr * A.w; ph.h = ph.w * ph.ih / ph.iw; ph.cx = gp.cxr * A.w; ph.cy = A.top + gp.cyr * A.h; ph.rot = gp.rot; ph.flip = gp.flip; ph.preset = 'custom';
      } else {
        var ar = ph.ih / ph.iw, room = gp.preset !== 'pocket' ? textRoom(A) : 0, w;
        if (gp.preset === 'pocket') { w = Math.min(3.5, 3.5 / ar); ph.cx = 3.75; }
        else { w = (gp.preset === 'small' ? 0.7 : 1) * A.w; if (w * ar > A.h - room) w = (A.h - room) / ar; ph.cx = 0; }
        ph.w = w; ph.h = w * ar; ph.rot = 0; ph.cy = A.top + (gp.preset === 'pocket' ? 1 : 0) + ph.h / 2; ph.preset = gp.preset;
      }
      clamp();
    }
    G.placedFor = placeKey();
  }
  // The group name line and the person's name, centred under the design, each scaled to fit the area.
  function layoutText() {
    var A = area(), p = G.people[G.sel], pb = BP.photoBox(st.photo), c = ink();
    var top = st.photo && st.photo.preset === 'pocket' ? A.top + 5 : (pb ? pb.y + pb.h + 0.3 : A.top + 0.5);
    function line(s, sz) {
      var t = { s: s, f: G.font, c: c, picked: !!G.color, cx: 0, cy: 0, sz: sz, rot: 0 }, l = BP.textLocal(mctx, t);
      if (l && l.x1 - l.x0 > A.w * 0.9) { t.sz *= A.w * 0.9 / (l.x1 - l.x0); l = BP.textLocal(mctx, t); }
      t.cy = top - (l ? l.y0 : -t.sz * 0.4); top = t.cy + (l ? l.y1 : t.sz * 0.4) + 0.18;
      return t;
    }
    var g = groupLine();
    st.lines = g ? [line(g, nameSz(A) * 0.6)] : [];
    st.text = p && p.name ? line(p.name, nameSz(A)) : { s: '', f: G.font, c: c, picked: false, cx: 0, cy: 0, sz: 1.2, rot: 0 };
  }

  // Show the selected person (or, with nobody yet, the page's own shirt) on the stage.
  function groupShow(cb) {
    var p = G.people[G.sel], done = false, fin = function () { if (done) return; done = true; if (cb) cb(); };
    setTimeout(fin, 6000);
    var F = p ? useFit(p.fit) : (usePage(), fitOf(G.data.page));
    var was = st.photo; G.cur = p || null; st.photo = (p && p.photo) || G.main || null; if (st.photo !== was) { undoStack = []; thumbs(); }
    var ci = colorIdx(F, p ? colourFor(p) : colourFor({ fit: G.data.page }));
    st.color = ci < 0 ? 0 : ci; st.size = p ? p.size : '';
    loadPool();
    poolReady(function () {
      if (G.people[G.sel] !== p) return fin();
      var nth = 0; for (var i = 0; i < G.sel; i++) if (G.people[i].fit === (p && p.fit)) nth++;   // a different model per person
      var m = pool.list.length ? pool.list[nth % pool.list.length] : null;
      if (m && pool.slugs[st.color]) { st.model = m; setGeom(m); } else { st.model = null; setGeom(OWN); }
      st.view = 'full'; placeGroup(); layoutText();
      $('bpcLoading').hidden = false;
      loadShirt(st.color, function () { if (G.people[G.sel] === p) { $('bpcLoading').hidden = true; layoutText(); requestInk(); sync(); } fin(); });
      sync();
    });
  }
  function select(i) {
    capturePlace(); G.ownFor = null;
    G.sel = i; groupShow();
    [].forEach.call($('bpcGList').children, function (r) { r.classList.toggle('is-on', +r.dataset.i === i); });
    renderStrip();
  }

  // ---------- group panel ----------
  function setMode(group) {
    if (group === G.on) return;
    if (group) {
      G.single = { color: st.color, size: st.size, model: st.model, text: st.text, backOn: st.backOn, sleeveOn: st.sleeveOn };
      st.backOn = st.sleeveOn = false;
      if (!G.colour) G.colour = (PAGE.colors[st.color] || PAGE.colors[0]).name;
      G.main = st.photo; G.cur = null;
      G.on = true; modal.classList.add('is-group');
      if (st.photo) G.place = { preset: st.photo.preset && st.photo.preset !== 'custom' ? st.photo.preset : 'standard' };
      G.placedFor = null; renderAll(); G.sel = G.people.length ? 0 : -1; groupShow(); renderList();
    } else {
      capturePlace();
      if (st.photo !== G.main) { st.photo = G.main || null; undoStack = []; thumbs(); }
      G.cur = null;
      G.on = false; modal.classList.remove('is-group'); usePage(); st.lines = [];
      var s0 = G.single || {};
      st.color = s0.color || 0; st.size = s0.size || ''; st.text = s0.text || st.text; st.backOn = !!s0.backOn; st.sleeveOn = !!s0.sleeveOn;
      st.model = s0.model || null; setGeom(st.model || OWN);
      if (st.photo) applyPreset(st.photo.preset && st.photo.preset !== 'custom' ? st.photo.preset : 'standard', true);
      loadShirt(st.color, function () { $('bpcLoading').hidden = true; requestInk(); sync(); });
      sync();
    }
  }
  function thumbOf(p) { var F = fitOf(p.fit), i = colorIdx(F, colourFor(p)); return F && F.colors[i] ? abs(F.colors[i].thumb) : ''; }
  var IMG_ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="6" width="14" height="13" rx="2"/><circle cx="8" cy="11" r="1.5"/><path d="M17 16l-4-4-7 7"/><path d="M20.5 2.5v6M17.5 5.5h6"/></svg>';
  function opt(v, label, on) { return '<option value="' + esc(v) + '"' + (on ? ' selected' : '') + '>' + esc(label) + '</option>'; }
  function renderList() {
    var list = $('bpcGList');
    list.innerHTML = G.people.map(function (p, i) {
      var F = fitOf(p.fit);
      return '<div class="bpc-pr' + (i === G.sel ? ' is-on' : '') + (p.err ? ' is-err' : '') + '" data-i="' + i + '">'
        + '<span class="bpc-gav" aria-hidden="true"><img alt="" src="' + esc(thumbOf(p)) + '"></span>'
        + '<button type="button" class="bpc-pimg' + (p.photo ? ' is-set' : '') + '" data-img aria-label="' + esc((p.photo ? 'Change the image for ' : 'Own image for ') + pname(p)) + '" title="' + esc(p.photo ? 'Change ' + pname(p) + '’s image' : 'Give ' + pname(p) + ' their own image') + '">'
        + (p.photo ? '<img alt="" src="' + esc(p.photo.orig.el.src) + '">' : IMG_ICON) + '</button>'
        + '<input type="text" class="bpc-pn" data-f="name" value="' + esc(p.name) + '" maxlength="14" placeholder="No name" aria-label="Name on shirt" autocomplete="off">'
        + '<span class="bpc-gstep"><button type="button" data-q="-1" aria-label="One less">−</button><span>' + p.qty + '</span><button type="button" data-q="1" aria-label="One more">+</button></span>'
        + '<button type="button" class="bpc-px" data-remove aria-label="Remove ' + esc(pname(p)) + '">×</button>'
        + '<select data-f="fit" aria-label="Fit">' + G.data.fits.map(function (f) { return opt(f.key, f.label, f.key === p.fit); }).join('') + '</select>'
        + '<select data-f="size" aria-label="Size"' + (p.size ? '' : ' class="is-missing"') + '>' + (p.size ? '' : opt('', 'Size?', true)) + F.sizes.map(function (s) { return opt(s, sizeLabel(s), s === p.size); }).join('') + '</select>'
        + (G.same ? '' : '<select data-f="color" class="bpc-pc" aria-label="Colour">' + F.colors.map(function (c) { return opt(c.name, c.name, matchColor(c.name, colourFor(p))); }).join('') + '</select>')
        + '</div>';
    }).join('') + (G.people.length ? '<button type="button" class="bpc-pmore" id="bpcGMore"' + (G.people.length >= GMAX ? ' disabled' : '') + '>Add one more <span>+</span></button>' : '');
    $('bpcGList').classList.toggle('is-many', !G.same);
    renderCounts(); renderStrip(); renderColours();
  }
  function renderCounts() {
    var n = gShirts(), by = {};
    G.people.forEach(function (p) { by[p.fit] = (by[p.fit] || 0) + p.qty; });
    $('bpcGCount').textContent = G.people.length ? G.people.length + (G.people.length === 1 ? ' name · ' : ' names · ') + shirtsTxt(n) : 'none yet';
    $('bpcGFits').innerHTML = G.data.fits.filter(function (f) { return by[f.key]; }).map(function (f) { return '<span>' + esc(f.label) + ' ' + by[f.key] + '</span>'; }).join('');
    $('bpcGBulk').hidden = G.people.length < GMAX;
    $('bpcGAddNames').disabled = G.people.length >= GMAX;
  }
  function renderStrip() {
    $('bpcStrip').innerHTML = G.people.map(function (p, i) {
      return '<button type="button" data-sel="' + i + '" aria-pressed="' + (i === G.sel) + '"><span class="bpc-sth"><img alt="" src="' + esc(thumbOf(p)) + '">' + (p.qty > 1 ? '<i>×' + p.qty + '</i>' : '') + '</span><span class="bpc-stl">' + esc(pname(p)) + '</span></button>';
    }).join('');
  }
  // Colours: every colour any listing has; one a fit in the group isn't made in is shown faded.
  function allColours() {
    var out = [], seen = {};
    [fitOf(G.data.page)].concat(G.data.fits).forEach(function (F) { (F ? F.colors : []).forEach(function (c) { var k = clean(c.name); if (!seen[k]) { seen[k] = 1; out.push(c); } }); });
    return out;
  }
  function renderColours() {
    var used = {}; G.people.forEach(function (p) { used[p.fit] = 1; });
    if (!G.people.length) G.data.fits.forEach(function (f) { used[f.key] = 1; });
    $('bpcGColours').innerHTML = allColours().map(function (c) {
      var lacking = G.data.fits.filter(function (f) { return used[f.key] && colorIdx(f, c.name) < 0; }).map(function (f) { return f.label; });
      return '<button type="button" class="bpc-color' + (lacking.length ? ' is-na' : '') + '" data-gcolour="' + esc(c.name) + '" aria-pressed="' + matchColor(c.name, G.colour) + '" aria-label="' + esc(c.name + (lacking.length ? ' (not made for ' + lacking.join(', ') + ')' : '')) + '"><img alt="" src="' + esc(abs(c.thumb)) + '"></button>';
    }).join('');
    $('bpcGColourName').textContent = G.same ? G.colour : 'chosen per person';
    $('bpcGColours').hidden = !G.same;
    $('bpcGSame').setAttribute('aria-checked', G.same);
    var off = G.same ? G.people.filter(function (p) { return !matchColor(colourFor(p), G.colour); }) : [];
    var msg = $('bpcGColourMsg');
    if (off.length) {
      var fits = off.map(function (p) { return fitLabel(p.fit); }).filter(function (v, i, a) { return a.indexOf(v) === i; });
      msg.className = 'bpc-gmsg is-warn';
      msg.textContent = G.colour + ' isn’t made in ' + fits.join(' or ') + ' sizes. ' + off.map(function (p) { return pname(p); }).join(', ') + (off.length === 1 ? ' gets ' : ' get ') + colourFor(off[0]) + ', or pick another colour for everyone.';
    } else { msg.className = 'bpc-note'; msg.textContent = G.same ? 'Faded colours aren’t made in some of your sizes.' : 'Pick each person’s colour in their row.'; }
  }
  function renderAll() {
    $('bpcGName').value = G.gname;
    $('bpcGTypes').innerHTML = TYPES.map(function (t) { return '<button type="button" class="bpc-chip" data-type="' + t[0] + '" aria-pressed="' + (G.type === t[0]) + '">' + esc(t[1]) + '</button>'; }).join('');
    $('bpcGNames').placeholder = (TYPES.filter(function (t) { return t[0] === G.type; })[0] || TYPES[0])[2];
    each('bpcGPrint', function (b) { b.setAttribute('aria-pressed', b.dataset.gprint === G.gprint); });
    renderList();
  }
  function groupSync() {
    $('bpcMode').querySelectorAll('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', (b.dataset.mode === 'group') === G.on); });
    $('bpcGroup').hidden = $('bpcGSetup').hidden = $('bpcGColour').hidden = !G.on; $('bpcStrip').hidden = !G.on;
    if (!G.on) { $('bpcFrontH').textContent = 'Front print'; $('bpcAdd').textContent = 'Review & approve'; $('bpcNameStyle').hidden = true; st.lines = []; return; }
    claim(); capturePlace(); layoutText();
    st.layer = 'img'; $('bpcLayerSeg').hidden = true; $('bpcAdjust').hidden = !st.photo;   // names and the group line are placed for the group
    var own = holder() !== G;
    $('bpcFrontH').innerHTML = '<span class="bpc-gstepn">2</span>' + (own ? esc(pname(G.cur)) + '’s image <small>only on this shirt</small>' : 'Your logo or design <small>' + (G.people.some(function (q) { return !!q.photo; }) ? 'everyone without their own image' : 'same on every shirt') + '</small>');
    var anyText = !!groupLine() || G.people.some(function (q) { return !!q.name; });
    $('bpcNameStyle').hidden = $('bpcFonts').hidden = $('bpcTColors').hidden = !anyText;
    each('bpcFonts', function (b) { b.setAttribute('aria-pressed', b.dataset.fam === G.font); });
    each('bpcTColors', function (b) { b.setAttribute('aria-pressed', b.dataset.color === G.color); });
    var n = gShirts();
    $('bpcTotal').textContent = money(gTotal());
    $('bpcTotalNote').textContent = n ? shirtsTxt(n) + ' · ' + money(D.price + (backOn() ? D.extraPrice : 0)) + ' each' : 'No people yet';
    $('bpcAdd').textContent = 'Review all & approve';
    var p = G.people[G.sel];
    $('bpcWho').hidden = false;
    $('bpcWho').innerHTML = p ? '<b>' + esc(pname(p)) + '</b> · ' + esc(fitLabel(p.fit) + ' · ' + (p.size ? sizeLabel(p.size) : 'size?') + ' · ' + colourFor(p)) : 'Your design · add people to see each shirt';
  }
  function addNames(text) {
    var names = String(text || '').split(/[\n,;]+/).map(function (s) { return s.trim(); }).filter(Boolean);
    var room = GMAX - G.people.length; if (room <= 0) return;
    if (!names.length) names = [''];
    var start = G.people.length;
    names.slice(0, room).forEach(function (nm) { G.people.push(newPerson(nm)); });
    renderList(); capturePlace(); G.sel = start; groupShow(); renderList();
    return names.length > room ? names.length - room : 0;
  }
  function bindGroup() {
    $('bpcMode').addEventListener('click', function (e) { var b = e.target.closest('[data-mode]'); if (b) setMode(b.dataset.mode === 'group'); });
    $('bpcGName').addEventListener('input', function (e) { G.gname = e.target.value.slice(0, 30); $('bpcGNameErr').hidden = true; capturePlace(); placeGroup(); sync(); });
    $('bpcGTypes').addEventListener('click', function (e) { var b = e.target.closest('[data-type]'); if (b) { G.type = b.dataset.type; renderAll(); } });
    $('bpcGPrint').addEventListener('click', function (e) { var b = e.target.closest('[data-gprint]'); if (!b) return; G.gprint = b.dataset.gprint; each('bpcGPrint', function (x) { x.setAttribute('aria-pressed', x === b); }); capturePlace(); placeGroup(); sync(); });
    $('bpcGSame').addEventListener('click', function () {
      G.same = !G.same;
      if (!G.same) G.people.forEach(function (p) { p.color = colourFor(p); });   // start from what everyone has now
      renderList(); groupShow();
    });
    $('bpcGColours').addEventListener('click', function (e) { var b = e.target.closest('[data-gcolour]'); if (!b) return; G.colour = b.dataset.gcolour; renderList(); groupShow(); });
    $('bpcGAddNames').addEventListener('click', function () {
      var left = addNames($('bpcGNames').value); $('bpcGNames').value = '';
      $('bpcGNamesErr').hidden = !left; if (left) $('bpcGNamesErr').textContent = 'Up to ' + GMAX + ' people here; ' + left + ' name' + (left === 1 ? ' was' : 's were') + ' not added. For more, ask us for bulk pricing.';
      $('bpcGPeopleErr').hidden = true;
    });
    $('bpcStrip').addEventListener('click', function (e) { var b = e.target.closest('[data-sel]'); if (b) select(+b.dataset.sel); });
    var list = $('bpcGList');
    // v10.49 row picture box: styles and the hint live here so the snippet stays as in v10.48.
    var pcss = document.createElement('style'); pcss.textContent = '.bpc .bpc-pr{grid-template-columns:44px minmax(0,1fr) auto 44px;grid-template-areas:"av nm q x" "im fit sz sz"}.bpc .bpc-glist.is-many .bpc-pr{grid-template-areas:"av nm q x" "im fit sz sz" ". col col col"}.bpc .bpc-pr .bpc-gav{align-self:center;justify-self:center;margin-top:0}.bpc-pimg{grid-area:im;width:44px;height:44px;padding:0;border:1.5px dashed #c9c4c2;border-radius:10px;background:#fff;color:var(--muted);display:flex;align-items:center;justify-content:center;cursor:pointer;overflow:hidden}.bpc-pimg:hover{border-color:var(--red);color:var(--red)}.bpc-pimg.is-set{border:2px solid var(--red);background:#f6f4f3}.bpc-pimg img{width:100%;height:100%;object-fit:contain;display:block}'; document.head.appendChild(pcss);
    var hint = list.parentNode.querySelector('#bpcGFits + .bpc-note'); if (hint) hint.textContent += ' Tap the picture box in a row to give that person their own image.';
    var imgIn = document.createElement('input'); imgIn.type = 'file'; imgIn.accept = 'image/png,image/jpeg,image/webp'; imgIn.hidden = true; modal.appendChild(imgIn);
    imgIn.addEventListener('change', function () {
      var f = imgIn.files && imgIn.files[0], q = G.imgFor; imgIn.value = ''; G.imgFor = null;
      if (!f || !q) return;
      var err = $('bpcGNamesErr');
      if (f.size > MAX_MB * 1048576) { err.textContent = 'This image is over ' + MAX_MB + ' MB. Please choose a smaller one.'; err.hidden = false; return; }
      var im = new Image();
      im.onload = function () {
        var i = G.people.indexOf(q); if (i < 0) return;
        err.hidden = true; capturePlace(); G.sel = i; G.cur = q; G.ownFor = q;
        setPhoto(f, im); G.ownFor = null; renderList(); groupShow();
      };
      im.onerror = function () { err.textContent = 'This image type cannot be shown. Please choose a JPG or PNG.'; err.hidden = false; };
      im.src = URL.createObjectURL(f);
    });
    list.addEventListener('click', function (e) {
      if (e.target.closest('#bpcGMore')) { addNames(''); var inp = list.querySelector('[data-i="' + (G.people.length - 1) + '"] .bpc-pn'); if (inp) inp.focus(); return; }
      var row = e.target.closest('[data-i]'); if (!row) return;
      var i = +row.dataset.i, p = G.people[i], b;
      if (e.target.closest('[data-img]')) { G.imgFor = p; imgIn.click(); return; }
      if ((b = e.target.closest('[data-q]'))) { p.qty = Math.max(1, Math.min(50, p.qty + +b.dataset.q)); b.parentNode.children[1].textContent = p.qty; renderCounts(); renderStrip(); if (i !== G.sel) select(i); else sync(); return; }
      if (e.target.closest('[data-remove]')) { G.people.splice(i, 1); capturePlace(); G.sel = Math.min(i, G.people.length - 1); groupShow(); renderList(); return; }
      if (i !== G.sel && !e.target.closest('select')) select(i);
    });
    list.addEventListener('focusin', function (e) { var row = e.target.closest('[data-i]'); if (row && +row.dataset.i !== G.sel) select(+row.dataset.i); });
    list.addEventListener('input', function (e) {
      if (e.target.dataset.f !== 'name') return;
      var i = +e.target.closest('[data-i]').dataset.i, p = G.people[i], pos = e.target.selectionStart;
      p.name = e.target.value.toUpperCase().slice(0, 14); e.target.value = p.name; try { e.target.setSelectionRange(pos, pos); } catch (er) {}
      var had = G.people.filter(function (q) { return !!q.name; }).length;
      if (i === G.sel) { placeGroup(); sync(); }
      var sb = $('bpcStrip').children[i]; if (sb) sb.lastChild.textContent = pname(p);
      if (!G.same) return; renderColours();
    });
    list.addEventListener('change', function (e) {
      var f = e.target.dataset.f; if (!f || f === 'name') return;
      var i = +e.target.closest('[data-i]').dataset.i, p = G.people[i];
      if (f === 'fit') { p.fit = e.target.value; if (fitOf(p.fit).sizes.indexOf(p.size) < 0) p.size = ''; if (!G.same && colorIdx(fitOf(p.fit), p.color) < 0) p.color = colourFor(p); }
      else if (f === 'size') { p.size = e.target.value; p.err = ''; }
      else if (f === 'color') p.color = e.target.value;
      capturePlace(); G.sel = i; renderList(); groupShow();
    });
    // name font and colour: one choice for the whole group
    $('bpcFonts').addEventListener('click', function (e) { var b = e.target.closest('[data-fam]'); if (b && G.on) { G.font = b.dataset.fam; capturePlace(); placeGroup(); sync(); } }, true);
    $('bpcTColors').addEventListener('click', function (e) { var b = e.target.closest('[data-color]'); if (b && G.on) { G.color = b.dataset.color; sync(); } }, true);
    modal.querySelectorAll('[data-greview-close]').forEach(function (b) { b.addEventListener('click', function () { if (!G.busy) $('bpcGReview').hidden = true; }); });
    $('bpcGConfirm').addEventListener('change', function () { $('bpcGApprove').disabled = !this.checked || G.busy || G.blocked; });
    $('bpcGApprove').addEventListener('click', groupApprove);
    $('bpcGCards').addEventListener('click', function (e) {
      var b = e.target.closest('[data-edit]'); if (!b || G.busy) return;
      $('bpcGReview').hidden = true; var i = +b.dataset.edit; select(i);
      var row = list.querySelector('[data-i="' + i + '"]'); if (row) showMissing(row, row.querySelector('.bpc-pn'));
    });
  }

  // ---------- review all + approve ----------
  function showPerson(i) { return new Promise(function (ok) { if (G.sel !== i) capturePlace(); G.sel = i; groupShow(ok); }); }
  function groupCheck() {
    if (G.gprint !== 'none' && !G.gname.trim()) { $('bpcGNameErr').hidden = false; showMissing($('bpcGSetup'), $('bpcGName')); return false; }
    var lack = -1; G.people.forEach(function (q, i) { if (!q.photo && lack < 0) lack = i; });
    if (!G.main && (!G.people.length || lack > -1)) {
      var some = G.people.some(function (q) { return !!q.photo; });
      if (some) select(lack);
      $('bpcDesignErr').textContent = some ? 'Upload a design for everyone, or an image for ' + pname(G.people[lack]) + '.' : 'Upload your logo or design first.';
      $('bpcDesignErr').hidden = false; showMissing($('bpcFrontSec'), $('bpcFrontFile').previousElementSibling); return false;
    }
    if (!G.people.length) { $('bpcGPeopleErr').hidden = false; showMissing($('bpcGroup'), $('bpcGNames')); return false; }
    var bad = -1;
    G.people.forEach(function (p, i) { p.err = p.size ? '' : 'size'; if (p.err && bad < 0) bad = i; });
    if (bad > -1) {
      renderList(); select(bad);
      var row = $('bpcGList').querySelector('[data-i="' + bad + '"]'); if (row) showMissing(row, row.querySelector('[data-f="size"]'));
      return false;
    }
    return true;
  }
  async function groupReview() {
    if (!groupCheck()) return;
    var keep = G.sel, n = G.people.length;
    $('bpcGConfirm').checked = false; $('bpcGConfirm').disabled = false; $('bpcGApprove').disabled = true; $('bpcGReviewErr').hidden = true;
    $('bpcGReviewH').textContent = 'Review: ' + (G.gname.trim() || 'your group order');
    $('bpcGApprove').textContent = 'Approve & add ' + shirtsTxt(gShirts()) + ' · ' + money(gTotal());
    $('bpcGCards').innerHTML = G.people.map(function (p, i) {
      return '<div class="bpc-gcard"><div class="bpc-gshot" id="bpcGShot' + i + '"><span class="bpc-spin"></span></div><div class="bpc-gmeta"><b>' + esc(pname(p)) + (p.qty > 1 ? ' <em>×' + p.qty + '</em>' : '') + '</b><span>' + esc(fitLabel(p.fit) + ' · ' + sizeLabel(p.size) + ' · ' + colourFor(p)) + '</span><button type="button" class="bpc-link" data-edit="' + i + '">Edit</button></div></div>';
    }).join('');
    $('bpcGChecks').innerHTML = '';
    $('bpcGReview').hidden = false; G.busy = true;
    var minDpi = Infinity, unavailable = [];
    for (var i = 0; i < n; i++) {
      await showPerson(i);
      var v = findVariant(); if (!v || !v.available) unavailable.push(pname(G.people[i]) + ' (' + fitLabel(G.people[i].fit) + ' ' + sizeLabel(G.people[i].size) + ')');
      if (st.photo) minDpi = Math.min(minDpi, st.photo.iw / st.photo.w);
      var im = new Image(); im.alt = ''; im.src = lookImage().toDataURL('image/jpeg', 0.82);
      var box = $('bpcGShot' + i); if (box) { box.innerHTML = ''; box.appendChild(im); }
    }
    G.busy = false; await showPerson(keep < 0 ? 0 : keep); renderList();
    var checks = [], dpi = minDpi < Infinity ? Math.round(minDpi) : 0, off = G.people.filter(function (q) { return G.same && !matchColor(colourFor(q), G.colour); });
    if (unavailable.length) checks.push(['bad', 'Sold out in that colour and size: ' + unavailable.join(', ') + '. Tap Edit to change it.']);
    else checks.push(['ok', 'Everyone has a size' + (G.same ? (off.length ? '' : ', all in ' + G.colour) : '')]);
    if (off.length) checks.push(['warn', off.map(function (q) { return pname(q); }).join(', ') + ': ' + G.colour + ' isn’t made in their size, so ' + (off.length === 1 ? 'it is ' : 'they are ') + colourFor(off[0]) + '.']);
    var owns = G.people.filter(function (q) { return !!q.photo; }).length;
    if (dpi >= 150) checks.push(['ok', (owns ? 'Every image prints' : 'Your design prints') + ' sharp on every shirt']);
    else if (dpi >= 100) checks.push(['warn', 'Good print. A larger design file would print sharper on the biggest shirts.']);
    else checks.push(['bad', 'May print blurry on the biggest shirts. Use a bigger design file.']);
    if (owns) checks.push(['info', owns + (owns === 1 ? ' person has' : ' people have') + ' their own image']);
    if (groupLine()) checks.push(['info', '“' + groupLine() + '” is printed under the design on all ' + shirtsTxt(gShirts())]);
    if (backOn()) checks.push(['info', '“' + G.gname.trim().toUpperCase() + '” is printed on the back of all ' + shirtsTxt(gShirts()) + ' (+' + money(D.extraPrice) + ' a shirt)']);
    var noName = G.people.filter(function (q) { return !q.name; }).length;
    if (noName && noName < G.people.length) checks.push(['info', noName + (noName === 1 ? ' row has' : ' rows have') + ' no name on the shirt']);
    $('bpcGChecks').innerHTML = checks.map(function (c) { return '<li class="bpc-w-' + c[0] + '"></li>'; }).join('');
    [].forEach.call($('bpcGChecks').children, function (li, k) { li.textContent = checks[k][1]; });
    G.blocked = unavailable.length > 0;
    $('bpcGConfirm').disabled = G.blocked;
    $('bpcGApprove').disabled = G.blocked || !$('bpcGConfirm').checked;
  }
  async function addLine(p, v, gid, k, n, when) {
    st.passId = newId();
    var pass = await toBlob(makePass(when), 'image/jpeg', 0.86), look = await toBlob(lookImage(), 'image/jpeg', 0.86);
    var A = area(), d = design(), u = BP.union(mctx, d), ph = st.photo, uid = String(Date.now()) + '-' + k, back = backOn(), gn = G.gname.trim();
    var fd = new FormData();
    fd.append('id', v.id); fd.append('quantity', p.qty);
    fd.append('properties[Design ID]', st.passId);
    fd.append('properties[Group]', gid + ' · ' + (gn || 'Group') + ' · ' + pname(p) + ' (' + (k + 1) + ' of ' + n + ')');
    fd.append('properties[Print]', printSummary() + (back ? ' + Back: “' + gn.toUpperCase() + '”' : ''));
    fd.append('properties[Print size]', presetLabel());
    if (p.name) fd.append('properties[Text]', '“' + p.name + '” · ' + BP.FONTS[BP.fontIndex(G.font)].label);
    if (groupLine()) fd.append('properties[Group name]', '“' + groupLine() + '” under the design');
    if (back) { fd.append('properties[Back print]', '“' + gn.toUpperCase() + '” (group name)'); fd.append('properties[Extra Prints]', '1 × ' + money(D.extraPrice)); }
    fd.append('properties[_Shown on]', st.model ? st.model.label : 'Our model');
    fd.append('properties[Approved]', stamp(when));
    var wa = $('bpcWhatsapp').value.trim(); if (wa) fd.append('properties[WhatsApp]', wa);
    var note = $('bpcNote').value.trim(); if (note) fd.append('properties[Note for designer]', note);
    fd.append('properties[_unique]', uid); fd.append('properties[_extras]', back ? '1' : '0'); fd.append('properties[_Color]', colorName());
    if (pass) fd.append('properties[_Design Pass]', new File([pass], st.passId + '-pass.jpg', { type: 'image/jpeg' }));
    if (look) fd.append('properties[_Preview]', new File([look], st.passId + '-shirt.jpg', { type: 'image/jpeg' }));
    if (ph.mode === 'cut' || ph.mode === 'ink') {
      var ver = ph.mode === 'ink' ? ph.ink : ph.cut, outBlob = ver.blob || await toBlob(ver.canvas, 'image/png');
      var base0 = String(ph.orig.file.name || 'design'); if (base0.lastIndexOf('.') > 0) base0 = base0.slice(0, base0.lastIndexOf('.'));
      fd.append('properties[_Front File]', new File([outBlob], base0 + (ph.mode === 'ink' ? '-adjusted.png' : '-cutout.png'), { type: 'image/png' }));
      fd.append('properties[_Front Original]', ph.orig.file);
    } else fd.append('properties[_Front File]', ph.orig.file);
    var res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error(await res.text());
    var item = await res.json(), pr = item.properties || {};
    var tl = function (t) { return { s: t.s, f: t.f, c: t.c, cx: t.cx, cy: t.cy, sz: t.sz, rot: t.rot }; };
    var data = {
      v: 2, id: st.passId, ts: when.toISOString(), t: D.title, pu: D.url, c: colorName(), s: st.size, a: [A.w, A.h, A.top],
      photo: { u: pr['_Front File'] || '', o: pr['_Front Original'] || '', cut: ph.mode === 'cut' || (ph.mode === 'ink' && ph.ink.base === 'cut') ? 1 : 0, ink: ph.mode === 'ink' ? 1 : 0, cx: ph.cx, cy: ph.cy, w: ph.w, h: ph.h, iw: ph.iw, ih: ph.ih, rot: ph.rot, flip: ph.flip ? 1 : 0 },
      text: st.text.s ? tl(st.text) : null, lines: (st.lines || []).map(tl),
      box: u ? [u.x, u.y, u.w, u.h] : null, back: '', sl: '', side: '', pass: pr['_Design Pass'] || '', p: (D.price + (back ? D.extraPrice : 0)) * p.qty, g: gid,
      bt: back ? { s: gn.toUpperCase(), f: G.font, c: st.text.c || ink(), w: Math.min(10, A.w * 0.85) } : null
    };
    var enc = BP.encode(data), base = location.origin;
    var extra = { '_Print File': base + '/pages/print-file?d=' + enc + previewParam(), '_Share': base + '/pages/design-pass?d=' + enc + previewParam() };
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: p.qty, properties: Object.assign({}, pr, extra) }) });
    if (back && D.extraId) {
      var r2 = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: D.extraId, quantity: p.qty, properties: { 'Design ID': st.passId, 'For': 'Back: “' + gn.toUpperCase() + '” · ' + pname(p), '_link': uid } }] }) });
      if (!r2.ok) throw new Error('extra');
    }
  }
  async function groupApprove() {
    var btn = $('bpcGApprove'), n = G.people.length, done = 0, when = new Date(), gid = 'G-' + newId().slice(2);
    btn.disabled = true; G.busy = true; $('bpcGReviewErr').hidden = true;
    try {
      for (var i = 0; i < n; i++) {
        btn.textContent = 'Adding ' + (i + 1) + ' of ' + n + '…';
        await showPerson(i);
        var v = findVariant(); if (!v || !v.available) throw new Error('soldout');
        await addLine(G.people[i], v, gid, i, n, when); done++;
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error('BP group:', err);
      G.busy = false;
      $('bpcGReviewErr').textContent = done
        ? done + ' of ' + n + ' people were added to your cart. The rest could not be added. Check your cart before trying again, so nothing is ordered twice.'
        : 'Could not add to cart. Check your connection and try again. If your design file is very large, try a smaller one.';
      $('bpcGReviewErr').hidden = false; btn.disabled = false; btn.textContent = 'Approve & add ' + shirtsTxt(gShirts()) + ' · ' + money(gTotal());
    }
  }
  if (G.data) {
    PAGE = { colors: D.colors, variants: D.variants, sizes: D.sizes, title: D.title, url: D.url, price: D.price };
    // the page's own listing is shared with the group rows (same colour order, same model list)
    G.data.fits.forEach(function (f) { if (f.style === pageStyle) { f.colors = PAGE.colors; f.variants = PAGE.variants; f.sizes = PAGE.sizes; f.price = PAGE.price; } });
    G.data.fits = G.data.fits.filter(function (f) { return f.colors && f.colors.length && f.sizes && f.sizes.length; });
    Object.assign(G, { type: 'company', gname: '', gprint: 'under', same: true, colour: '' });
    bindGroup();
    // v10.48: on phones and tablets the photo fills the screen, so the Just me / For a group switch
    // sits above it (it was below, behind the price bar); on computers it stays in the side panel.
    var mq = window.matchMedia('(max-width: 999px)'), modeSw = $('bpcMode'), h2 = modal.querySelector('.bpc-h2');
    var placeMode = function () {
      if (mq.matches) { var stg = modal.querySelector('.bpc-stage'); stg.insertBefore(modeSw, stg.querySelector('.bpc-canvaswrap')); modeSw.classList.add('is-top'); }
      else { h2.parentNode.insertBefore(modeSw, h2.nextSibling); modeSw.classList.remove('is-top'); }
    };
    placeMode(); if (mq.addEventListener) mq.addEventListener('change', placeMode); else mq.addListener(placeMode);
  }

  build(); sync();
  loadPool();   // model list ready before the customer opens the customizer
  var q = new URLSearchParams(location.search);
  if (q.get('remix')) remix(q.get('remix'));
  else if (q.get('openCustomize') === 'true') open();
})();

